<ion-header [translucent]="true">
  <ion-toolbar color="primary">
    <ion-buttons slot="start">
      <ion-menu-button></ion-menu-button>
    </ion-buttons>
    <ion-title>Értékelés, feljegyzés, mulasztás</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content [fullscreen]="true">
  <!-- Nem az aktuális tanévet nézzük: a képernyő olvasható, de írni nem lehet.
       Enélkül a felhasználó azt hinné, az aktuális tanévet látja, és üres névsorra,
       hiányzó jegyekre panaszkodna – valójában másik év adatait nézi. -->
  <div class="tanev-figyelmezteto" *ngIf="masTanevetNez">
    <ion-icon name="time-outline"></ion-icon>
    <div>
      <b>A {{ tanevNeve(megjelenitettTanev) }} tanévet nézed</b> – az intézmény aktuális tanéve
      {{ tanevNeve(aktualisTanev) }}. Az osztályok, a névsor és a jegyek ennek az évnek az
      állapotát mutatják. <b>Új értékelés ide nem rögzíthető</b>; váltás a fejléc
      tanév-választójában.
    </div>
  </div>
  <div>

    <div>
      <!-- A gondviselői nézetnek (uzemmod 4) nincs szüksége az osztály- és a
           dolgozói törzsre: ott egyetlen tanuló adatait mutatjuk. Ha ezektől
           tennénk függővé a fejlécet, a tanulói belépés üres képernyőt kapna
           akkor is, amikor csak a törzsadat-lekérés nem jött vissza. -->
      <ion-grid *ngIf="(osztaly && allomany) || uzemmod == '4'">
        <ion-row>
          <ion-col>
            <ng-select disabled (change)="kivalaszt('tanar',$event)" appendTo="body" [notFoundText]="'Nincs találat'"
              [items]="[{'n':'Értékelés','i':'1'},{'n':'Mulasztás','i':'2'},{'n':'Feljegyzés','i':'3'},{'n':'Gondviselő','i':'4'},{'n':'Záróértékelés','i':'5'},{'n':'Számonkérések','i':'6'}]"
              placeholder="Művelet*" bindValue="i" [multiple]="false" [closeOnSelect]="true" [(ngModel)]="kivtanar"
              label-placement="stacked" fill="outline" bindLabel="n">
            </ng-select>
          </ion-col>
          <ion-col *ngIf="uzemmod != '4'">
            <!-- Osztály VAGY csoport. Az érték összetett (`o:<id>` / `c:<id>`), mert
                 ugyanahhoz az osztályhoz több csoport is tartozhat — puszta osztály-
                 azonosítóval nem lehetne megkülönböztetni őket. A lista a kiszolgálótól
                 jön, a kilét szerint szűrve: a pedagógus csak a sajátjait kapja. -->
            <ng-select (change)="kivalaszt('osztaly',$event)" appendTo="body" [notFoundText]="'Nincs találat'"
              [items]="osztaly" [placeholder]="tanitottAdmin ? 'Osztály / csoport* (kereshető)' : 'Osztály / csoport*'"
              bindValue="ertek" [multiple]="false" [closeOnSelect]="true"
              [(ngModel)]="kivosztalyErtek" label-placement="stacked" fill="outline" bindLabel="nev">
              <ng-template ng-option-tmp let-item="item">
                <span>{{ item.nev }}</span>
                <span *ngIf="item.tipus === 'csoport'" class="ert-cimke">csoport</span>
                <span *ngIf="item.sajat && tanitottAdmin" class="ert-cimke ert-sajat">saját</span>
                <span *ngIf="item.helyettesitett && !item.sajat" class="ert-cimke">helyettesített</span>
              </ng-template>
            </ng-select>
            <!-- Ahol csak helyettesített, az a csoport alapból nem látszik. -->
            <ion-checkbox *ngIf="helyettesitettDb" class="ert-helyettesitett-pipa" label-placement="end"
              [(ngModel)]="helyettesitettMutat" (ionChange)="osztalyValasztekFrissit()">
              Helyettesített csoportok ({{ helyettesitettDb }})
            </ion-checkbox>
          </ion-col>
          <ion-col *ngIf="uzemmod == '1' || uzemmod == '5' || uzemmod == '6'">
            <ng-select (change)="kivalaszt('tantargy',$event)" appendTo="body" [notFoundText]="'Nincs találat'"
              [items]="tantargyValasztek" placeholder="Tantárgy*" bindValue="id" [multiple]="false" [closeOnSelect]="true"
              [(ngModel)]="kivtantargy" label-placement="stacked" fill="outline" bindLabel="name">
            </ng-select>
            <!-- A választó alapból csak az itt, órarend szerint tanított tárgyakat mutatja. -->
            <a *ngIf="tantargySzukitve" class="ert-tantargy-kapcsolo" (click)="mindenTantargyValt()">
              {{ mindenTantargy ? 'Csak az itt tanított tantárgyak' : 'Összes tantárgy mutatása' }}
            </a>
          </ion-col>
          <ion-col *ngIf="uzemmod == '2'">
            <ion-input (change)="kivalaszt('datum',$event)" label="Hét" [(ngModel)]="kivdatum" label-placement="stacked"
              fill="outline" type="week" placeholder="YYYY-W##" min="2012-W32"><ion-icon slot="start" name="time"
                aria-hidden="true"></ion-icon></ion-input>
          </ion-col>
          <!-- Tanulói belépésnél nincs mit választani: a saját nevét írjuk ki, rögzítve.
               Legördülővel a képernyő azt sugallná, hogy van másik választás is. -->
          <ion-col *ngIf="uzemmod == '4' && sajatSor">
            <ion-input label="Tanuló" label-placement="stacked" fill="outline" readonly
                       [value]="sajatSor.full_name || sajatSor.name">
              <ion-icon slot="start" name="person" aria-hidden="true"></ion-icon>
            </ion-input>
          </ion-col>
          <ion-col *ngIf="uzemmod == '4' && !sajatSor">
            <ng-select (change)="kivalaszt('tanulo',$event)" appendTo="body" [notFoundText]="'Nincs találat'"
              [items]="sztanulok" placeholder="Tanuló*" bindValue="oktazon" [multiple]="false" [closeOnSelect]="true"
              [(ngModel)]="kivtanulo" label-placement="stacked" fill="outline" bindLabel="name">
            </ng-select>
          </ion-col>
        </ion-row>
      </ion-grid>

      <!--  Ha a betöltéshez még hiányzik valami, MONDJUK MEG. Csoportot választva
            eddig némán nem történt semmi, mert a tantárgy is kell hozzá.  -->
      <ion-note color="medium" class="ert-hianyzik" *ngIf="miHianyzik && !kivalasztottOra">
        <ion-icon name="information-circle-outline"></ion-icon> {{ miHianyzik }}
      </ion-note>

      <ion-grid class="ertk-lap" *ngIf="kivalasztottOra && uzemmod == '1' && kivalasztottOra.osztaly_nevsor && kivalasztottOra.ertekelesek">
        <!-- A KIVÁLASZTOTT TANTÁRGY FEJLÉCE – ugyanaz a kártya, mint a napló értékelés-ablakában. -->
        <div class="ertk-fejkartya">
          <div class="ertk-fej-ikon" aria-hidden="true"><ion-icon name="school-outline"></ion-icon></div>
          <div class="ertk-fej-szoveg">
            <h2 class="ertk-fej-cim">{{ kivalasztottOra?.tantargy || 'Értékelés' }}</h2>
            <div class="ertk-chipek">
              <span class="ertk-chip"><ion-icon name="people-outline" aria-hidden="true"></ion-icon>{{kivalasztottOra.osztaly_nevsor.length}} fő</span>
              <span class="ertk-chip" *ngIf="kivalasztottOra.datum"><ion-icon name="calendar-outline" aria-hidden="true"></ion-icon>{{ kivalasztottOra.datum | date:'yyyy.MM.dd.' }}</span>
            </div>
          </div>
        </div>

        <!-- A SZÁMONKÉRÉS ADATAI: egységes címkék, rugalmas rács (mobilon egymás alatt). -->
        <div class="ertk-urlap">
          <div class="ertk-mezo">
            <label class="ertk-cimke" for="szam-tipus">Számonkérés típusa<span class="ertk-kotelezo">*</span></label>
            <select id="szam-tipus" class="ertk-select" name="jelenlet" [(ngModel)]="kivalasztottOra.szam_tipus">
              <option
                [ngValue]="'' + it.id"
                [disabled]="isTechnikaiErtekelesTipus(it)"
                [hidden]="isTechnikaiErtekelesTipus(it) && ('' + kivalasztottOra.szam_tipus) !== ('' + it.id)"
                *ngFor="let it of valaszthatoTipusok(kivalasztottOra?.szam_tipus)">
                {{it.nev}}
              </option>
            </select>
          </div>
          <div class="ertk-mezo">
            <label class="ertk-cimke">Dátum</label>
            <ion-input class="ertk-input" type="date" [(ngModel)]="kivalasztottOra.datum"></ion-input>
          </div>
          <div class="ertk-mezo ertk-mezo-szeles">
            <label class="ertk-cimke">Téma</label>
            <ion-input class="ertk-input" type="text" placeholder="téma" [(ngModel)]="kivalasztottOra.szam_tema"></ion-input>
          </div>
          <div class="ertk-mezo">
            <label class="ertk-cimke" for="osztalyozasimod">Osztályozási mód<span class="ertk-kotelezo">*</span></label>
            <select id="osztalyozasimod" class="ertk-select" [(ngModel)]="kivalasztottOra.osztalyozasimod" [disabled]="!!osztalyozasiModZar">
              <option value="1">Osztályzat (1-5)</option>
              <option value="4">Fokozat (Példás/Jó/Változó/Hanyag)</option>
              <option value="2">Százalék</option>
              <option value="3" disabled>Szöveg</option>
            </select>
          </div>
          <span class="mod-zar ertk-mod-zar" *ngIf="osztalyozasiModZar">
            <ion-icon name="lock-closed"></ion-icon>
            A tantárgy jegyei már „{{ osztalyozasiModZar.nev }}” formában vannak, ezért a mód nem változtatható. Váltani a meglévő jegyek törlése után lehet.
          </span>
        </div>

        <div class="ertk-szakaszfej">
          <h3>Névsor</h3>
          <span class="ertk-letszam">{{kivalasztottOra.osztaly_nevsor.length}} fő</span>
        </div>
        <!-- TÖMEGES ÉRTÉKELÉS. Egy dolgozat után 25 tanulónak egyenként ugyanazt
             beírni fölösleges kattintás; a típust a fenti választó adja, tehát ez
             bármelyik értékelési típusnál működik. -->
        <div class="tomeges-sav" *ngIf="kivalasztottOra?.osztaly_nevsor?.length">
          <b>Tömeges kitöltés</b>
          <ng-container *ngIf="kivalasztottOra?.osztalyozasimod === '4' || isDualFokozatMode()">
            <span class="cimke" *ngIf="isDualFokozatMode()">Magatartás:</span>
            <ion-button *ngFor="let f of FOKOZAT_GOMBOK" size="small" fill="outline"
                        (click)="tomegesErtek(f.ertek, 'mind')">{{ f.rovid }}</ion-button>
            <ng-container *ngIf="isDualFokozatMode()">
              <span class="cimke">Szorgalom:</span>
              <ion-button *ngFor="let f of FOKOZAT_GOMBOK" size="small" fill="outline" color="tertiary"
                          (click)="tomegesErtek(f.ertek, 'mind', 'szorgalomodost')">{{ f.rovid }}</ion-button>
            </ng-container>
          </ng-container>
          <ng-container *ngIf="kivalasztottOra?.osztalyozasimod !== '4' && !isDualFokozatMode()">
            <ion-input class="tomeges-mezo" type="number" [(ngModel)]="tomegesErtekMezo"
                       [placeholder]="kivalasztottOra?.osztalyozasimod === '2' ? '%' : '1-5'"
                       [min]="kivalasztottOra?.osztalyozasimod === '2' ? 0 : 1"
                       [max]="kivalasztottOra?.osztalyozasimod === '2' ? 100 : 5"></ion-input>
            <ion-button size="small" (click)="tomegesSzam('mind')">Mindenkinek</ion-button>
            <ion-button size="small" fill="outline" (click)="tomegesSzam('ures')"
                        [disabled]="!tomegesUresek">
              Csak az üreseknek ({{ tomegesUresek }})
            </ion-button>
            <!-- Aki nem írta meg: a jegyek beírása után a maradék egy lépésben „–”. -->
            <ion-button size="small" fill="outline" color="medium" *ngIf="nemIrtaLehet"
                        (click)="tomegesErtek(NEM_IRTA_JEL, 'ures')" [disabled]="!tomegesUresek"
                        title="Nem írta meg: az üresen maradt tanulók „–” jelet kapnak">
              Üreseknek: – nem írta meg
            </ion-button>
          </ng-container>
          <ion-button size="small" fill="clear" color="medium" (click)="tomegesErtek('', 'mind')">
            Mindenkinél törlés
          </ion-button>
          <!-- NKP-eredmények: a bemásolt listából kitölti a névsort (százalék vagy ponthatáros jegy). -->
          <ion-button size="small" fill="outline" color="tertiary"
                      *ngIf="kivalasztottOra?.osztalyozasimod === '1' || kivalasztottOra?.osztalyozasimod === '2'"
                      (click)="nkpBeillesztes()" title="A Nemzeti Köznevelési Portál eredménylistájának bemásolása">
            <ion-icon slot="start" name="clipboard-outline"></ion-icon> NKP-eredmények beillesztése
          </ion-button>
        </div>

            <div class="scrollable-table ertk-tabla-burok">
              <table class="ertekeles ertk-tabla">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Név</th>
                    <th>09</th>
                    <th>10</th>
                    <th>11</th>
                    <th>12</th>
                    <th>01/I</th>
                    <th>I</th>
                    <th>Átlag</th>
                    <th>01/II</th>
                    <th>02</th>
                    <th>03</th>
                    <th>04</th>
                    <th>05</th>
                    <th>06</th>
                    <th>II</th>
                    <th>Átlag</th>
                    <th>
                      {{
                        isDualFokozatMode()
                          ? 'Magatartás / Szorgalom'
                          : (kivalasztottOra?.osztalyozasimod === '4'
                          ? 'Fokozat'
                          : (kivalasztottOra?.osztalyozasimod === '2' ? 'Százalék' : 'Jegy (1-5)'))
                      }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <ng-container
                    *ngFor="let n of kivalasztottOra.osztaly_nevsor; let j = index">
                    <tr [class.ertk-kilepett]="n.kilepett" [title]="n.kilepett ? 'Már nem jár ide (utolsó nap: ' + n.kilepett + ') – a jegyei a törzslap miatt láthatók' : ''">
                      <td class="ertk-sorszam">{{j+1}}.</td>
                      <td class="ertk-nev"><app-profilkep class="nevsor-kep" tipus="tanulo" [azon]="n.oktazon" [nev]="n.viselt_vez + ' ' + n.viselt_ker"></app-profilkep>{{n.viselt_vez}} {{n.viselt_ker}}<small *ngIf="n.kilepett" class="ertk-kilepett-jel"> · kilépett {{n.kilepett}}</small></td>
                      <td class="ertk-honap" [attr.data-cimke]="h" *ngFor="let h of ['09','10','11','12','01/I']"><span
                          *ngFor="let item of kivalasztottOra.ertekelesek[n.oktazon]?.months[h]; let k = index">
                          <ion-button [attr.data-negyedev]="negyedevJel(item) || null" size="medium" fill="clear" [id]="'hover-trigger'+h+j+k" [class.negyedeves-jegy]="negyedevesE(item)" [class.nem-irta-jegy]="nemIrtaE(item)" [class.storno-jegy]="stornoE(item)"
                            style="color:{{item.szin}};--padding-start:0;--padding-end:0;margin:0" [title]="jegyHover(item)"><small *ngIf="negyedevesE(item)" class="negyedev-jel">{{negyedevJel(item)}}</small>{{jegyRovid(item)}}<ng-container *ngIf="!negyedevesE(item)">&nbsp;</ng-container></ion-button>
                          <ion-popover [trigger]="'hover-trigger'+h+j+k" triggerAction="click" showBackdrop=false>
                            <ng-template>
                              <ion-content class="ion-padding"><b>Téma:</b> {{item.tema}} <span *ngIf="nemIrtaE(item)"><br><b>Nem írta meg</b> – ha pótolta, a jegye a „Jegy beírása” gombbal kerül a helyére.</span><span
                                  *ngIf="item.ertekeles.length > 4"><br><b>Értékelés:</b>
                                  {{item.ertekeles}}</span><span *ngIf="getSpecialErtekelesReszletek(item.ertekeles) as special"><br><b>Magatartás:</b> {{special.magatartas}}<br><b>Szorgalom:</b> {{special.szorgalom}}</span><br><b>Dátum:</b>
                                {{item.targynap}}<br><b>Súlyozás:</b> {{item.szorzo}}%<br><b>Típus:</b>
                                {{negyedevesE(item) ? negyedevNev(item) : item.emnev}}<br><b>Tanár:</b> {{formatErtekelesTanar(item)}}<span *ngIf="item.modositva"><br><b>Módosítva:</b> {{item.modositva | date:'yyyy.MM.dd. HH:mm'}}</span><span *ngIf="stornoE(item)" class="storno-info"><br><b>Stornózva:</b> {{item.storno_ido}}{{item.stornozta_nev ? ' – ' + item.stornozta_nev : ''}}<br><b>Oka:</b> {{item.storno_ok || '-'}}</span><br><ion-button *ngIf="sajatTetel(item) && !stornoE(item)" (click)="modositJegy(item)" size="small" fill="outline">{{ nemIrtaE(item) ? 'Jegy beírása' : 'Módosítás' }}</ion-button> <ion-button *ngIf="sajatTetel(item) && !stornoE(item)" (click)="torolJegy(item)" size="small" color="danger">Stornó</ion-button> <ion-button (click)="elozmenyMutat('tanulo_ertekeles', item, 'Jegy előzménye')" size="small" fill="clear">Előzmény</ion-button></ion-content>
                            </ng-template>
                          </ion-popover></span></td>
                      <td class="ertk-felev" data-cimke="I. félév">
                        <span *ngFor="let fe of kivalasztottOra.ertekelesek[n.oktazon]?.felevi; let u = index">
                          <ion-button size="medium" fill="clear" [id]="'hover-trigger-felevi-'+u+j" [class.storno-jegy]="stornoE(fe)"
                            style="color:{{fe.szin}};--padding-start:0;--padding-end:0;margin:0" [title]="jegyHover(fe)">
                            {{jegyRovid(fe)}}&nbsp;
                          </ion-button>
                          <ion-popover [trigger]="'hover-trigger-felevi-'+u+j" triggerAction="click" showBackdrop=false>
                            <ng-template>
                              <ion-content class="ion-padding"><b>Téma:</b> {{fe.tema}} <span
                                  *ngIf="fe.ertekeles.length > 4"><br><b>Értékelés:</b>
                                  {{fe.ertekeles}}</span><span *ngIf="getSpecialErtekelesReszletek(fe.ertekeles) as special"><br><b>Magatartás:</b> {{special.magatartas}}<br><b>Szorgalom:</b> {{special.szorgalom}}</span><br><b>Dátum:</b>
                                {{fe.targynap}}<br><b>Súlyozás:</b>
                                {{fe.szorzo}}%<br><b>Típus:</b>
                                {{fe.emnev}}<br><b>Tanár:</b> {{formatErtekelesTanar(fe)}}<span *ngIf="fe.modositva"><br><b>Módosítva:</b> {{fe.modositva | date:'yyyy.MM.dd. HH:mm'}}</span><span *ngIf="stornoE(fe)" class="storno-info"><br><b>Stornózva:</b> {{fe.storno_ido}}{{fe.stornozta_nev ? ' – ' + fe.stornozta_nev : ''}}<br><b>Oka:</b> {{fe.storno_ok || '-'}}</span><br><ion-button *ngIf="sajatTetel(fe) && !stornoE(fe)" (click)="modositJegy(fe)" size="small" fill="outline">Módosítás</ion-button> <ion-button *ngIf="sajatTetel(fe) && !stornoE(fe)" (click)="torolJegy(fe)" size="small" color="danger">Stornó</ion-button> <ion-button (click)="elozmenyMutat('tanulo_ertekeles', fe, 'Záróértékelés előzménye')" size="small" fill="clear">Előzmény</ion-button></ion-content>
                            </ng-template>
                          </ion-popover>
                        </span>
                      </td>
                      <td class="ertk-atlag" data-cimke="Átlag (I)">{{formatAtlag(kivalasztottOra.ertekelesek[n.oktazon]?.atlagErtekelesFelev, kivalasztottOra.ertekelesek[n.oktazon]?.atlagErtekelesFelevSzazalek)}}
                      </td>
                      <td class="ertk-honap" [attr.data-cimke]="h" *ngFor="let h of ['01/II','02','03','04','05','06']"><span
                          *ngFor="let item of kivalasztottOra.ertekelesek[n.oktazon]?.months[h]; let k = index">
                          <ion-button [attr.data-negyedev]="negyedevJel(item) || null" size="medium" fill="clear" [id]="'hover-trigger'+h+j+k" [class.negyedeves-jegy]="negyedevesE(item)" [class.nem-irta-jegy]="nemIrtaE(item)" [class.storno-jegy]="stornoE(item)"
                            style="color:{{item.szin}};--padding-start:0;--padding-end:0;margin:0" [title]="jegyHover(item)"><small *ngIf="negyedevesE(item)" class="negyedev-jel">{{negyedevJel(item)}}</small>{{jegyRovid(item)}}<ng-container *ngIf="!negyedevesE(item)">&nbsp;</ng-container></ion-button>
                          <ion-popover [trigger]="'hover-trigger'+h+j+k" triggerAction="click" showBackdrop=false>
                            <ng-template>
                              <ion-content class="ion-padding"><b>Téma:</b> {{item.tema}} <span *ngIf="nemIrtaE(item)"><br><b>Nem írta meg</b> – ha pótolta, a jegye a „Jegy beírása” gombbal kerül a helyére.</span><span
                                  *ngIf="item.ertekeles.length > 4"><br><b>Értékelés:</b>
                                  {{item.ertekeles}}</span><span *ngIf="getSpecialErtekelesReszletek(item.ertekeles) as special"><br><b>Magatartás:</b> {{special.magatartas}}<br><b>Szorgalom:</b> {{special.szorgalom}}</span><br><b>Dátum:</b>
                                {{item.targynap}}<br><b>Súlyozás:</b> {{item.szorzo}}%<br><b>Típus:</b>
                                {{negyedevesE(item) ? negyedevNev(item) : item.emnev}}<br><b>Tanár:</b> {{formatErtekelesTanar(item)}}<span *ngIf="item.modositva"><br><b>Módosítva:</b> {{item.modositva | date:'yyyy.MM.dd. HH:mm'}}</span><span *ngIf="stornoE(item)" class="storno-info"><br><b>Stornózva:</b> {{item.storno_ido}}{{item.stornozta_nev ? ' – ' + item.stornozta_nev : ''}}<br><b>Oka:</b> {{item.storno_ok || '-'}}</span><br><ion-button *ngIf="sajatTetel(item) && !stornoE(item)" (click)="modositJegy(item)" size="small" fill="outline">{{ nemIrtaE(item) ? 'Jegy beírása' : 'Módosítás' }}</ion-button> <ion-button *ngIf="sajatTetel(item) && !stornoE(item)" (click)="torolJegy(item)" size="small" color="danger">Stornó</ion-button> <ion-button (click)="elozmenyMutat('tanulo_ertekeles', item, 'Jegy előzménye')" size="small" fill="clear">Előzmény</ion-button></ion-content>
                            </ng-template>
                          </ion-popover></span></td>
                      <td class="ertk-felev" data-cimke="II. félév">
                        <span *ngFor="let ev of kivalasztottOra.ertekelesek[n.oktazon]?.evvegi; let u = index">
                          <ion-button size="medium" fill="clear" [id]="'hover-trigger-evvegi-'+u+j" [class.storno-jegy]="stornoE(ev)"
                            style="color:{{ev.szin}};--padding-start:0;--padding-end:0;margin:0" [title]="jegyHover(ev)">
                            {{jegyRovid(ev)}}&nbsp;
                          </ion-button>
                          <ion-popover [trigger]="'hover-trigger-evvegi-'+u+j" triggerAction="click" showBackdrop=false>
                            <ng-template>
                              <ion-content class="ion-padding"><b>Téma:</b> {{ev.tema}} <span
                                  *ngIf="ev.ertekeles.length > 4"><br><b>Értékelés:</b>
                                  {{ev.ertekeles}}</span><span *ngIf="getSpecialErtekelesReszletek(ev.ertekeles) as special"><br><b>Magatartás:</b> {{special.magatartas}}<br><b>Szorgalom:</b> {{special.szorgalom}}</span><br><b>Dátum:</b>
                                {{ev.targynap}}<br><b>Súlyozás:</b>
                                {{ev.szorzo}}%<br><b>Típus:</b>
                                {{ev.emnev}}<br><b>Tanár:</b> {{formatErtekelesTanar(ev)}}<span *ngIf="ev.modositva"><br><b>Módosítva:</b> {{ev.modositva | date:'yyyy.MM.dd. HH:mm'}}</span><span *ngIf="stornoE(ev)" class="storno-info"><br><b>Stornózva:</b> {{ev.storno_ido}}{{ev.stornozta_nev ? ' – ' + ev.stornozta_nev : ''}}<br><b>Oka:</b> {{ev.storno_ok || '-'}}</span><br><ion-button *ngIf="sajatTetel(ev) && !stornoE(ev)" (click)="modositJegy(ev)" size="small" fill="outline">Módosítás</ion-button> <ion-button *ngIf="sajatTetel(ev) && !stornoE(ev)" (click)="torolJegy(ev)" size="small" color="danger">Stornó</ion-button> <ion-button (click)="elozmenyMutat('tanulo_ertekeles', ev, 'Záróértékelés előzménye')" size="small" fill="clear">Előzmény</ion-button></ion-content>
                            </ng-template>
                          </ion-popover>
                        </span>
                      </td>
                      <td class="ertk-atlag" data-cimke="Átlag (év)">{{formatAtlag(kivalasztottOra.ertekelesek[n.oktazon]?.atlagErtekeles, kivalasztottOra.ertekelesek[n.oktazon]?.atlagErtekelesSzazalek)}}</td>
                      <td class="ertk-beiro">
                        <ng-container *ngIf="isDualFokozatMode(); else singleModeInput">
                          <div style="display:flex;flex-direction:column;gap:6px;padding:4px">
                            <div style="display:flex;gap:4px;align-items:center;flex-wrap:wrap">
                              <span style="font-size:12px;min-width:22px">M:</span>
                              <ion-button
                                *ngFor="let f of FOKOZAT_GOMBOK"
                                size="small"
                                [fill]="kivalasztottOra.osztaly_nevsor[j].osztalyzat === f.ertek ? 'solid' : 'outline'"
                                (click)="kivalasztottOra.osztaly_nevsor[j].osztalyzat = f.ertek">
                                {{f.rovid}}
                              </ion-button>
                              <ion-button
                                size="small"
                                fill="clear"
                                color="medium"
                                (click)="kivalasztottOra.osztaly_nevsor[j].osztalyzat = ''">
                                X
                              </ion-button>
                            </div>
                            <div style="display:flex;gap:4px;align-items:center;flex-wrap:wrap">
                              <span style="font-size:12px;min-width:22px">Sz:</span>
                              <ion-button
                                *ngFor="let f of FOKOZAT_GOMBOK"
                                size="small"
                                [fill]="kivalasztottOra.osztaly_nevsor[j].szorgalomodost === f.ertek ? 'solid' : 'outline'"
                                (click)="kivalasztottOra.osztaly_nevsor[j].szorgalomodost = f.ertek">
                                {{f.rovid}}
                              </ion-button>
                              <ion-button
                                size="small"
                                fill="clear"
                                color="medium"
                                (click)="kivalasztottOra.osztaly_nevsor[j].szorgalomodost = ''">
                                X
                              </ion-button>
                            </div>
                          </div>
                        </ng-container>
                        <ng-template #singleModeInput>
                        <ng-container *ngIf="kivalasztottOra?.osztalyozasimod === '4'; else szamInput">
                          <div style="display:flex;gap:4px;justify-content:center;align-items:center;padding:4px;flex-wrap:wrap">
                            <ion-button
                              *ngFor="let f of FOKOZAT_GOMBOK"
                              size="small"
                              [fill]="kivalasztottOra.osztaly_nevsor[j].osztalyzat === f.ertek ? 'solid' : 'outline'"
                              (click)="kivalasztottOra.osztaly_nevsor[j].osztalyzat = f.ertek">
                              {{f.rovid}}
                            </ion-button>
                            <ion-button
                              size="small"
                              fill="clear"
                              color="medium"
                              (click)="kivalasztottOra.osztaly_nevsor[j].osztalyzat = ''">
                              X
                            </ion-button>
                          </div>
                        </ng-container>
                        </ng-template>
                        <ng-template #szamInput>
                          <!-- „NEM ÍRTA MEG” (–): jegy helyett mínusz annak, aki a dolgozatot nem írta meg.
                               Nem jegy – az átlagba nem számít, a KRÉTÁ-ba nem megy; pótlás után a jegyre
                               kattintva a „Jegy beírása” gombbal írható át. -->
                          <div class="jegy-beiro">
                            <!--  GOMBOK, NEM BEGÉPELÉS. Az érdemjegy öt értéket vehet fel;
                                  egy koppintás gyorsabb és nem lehet elgépelni. A már
                                  beírt jegy gombja kitöltött, újra megnyomva törlődik.
                                  Százalékos értékelésnél (mód 2) marad a szövegmező. -->
                            <div class="jegy-gombsor"
                                 *ngIf="jegyGombosMod(kivalasztottOra) && !nemIrtaJelE(kivalasztottOra.osztaly_nevsor[j].osztalyzat)">
                              <ion-button *ngFor="let g of JEGY_GOMBOK" size="small"
                                [fill]="jegyEgyezik(kivalasztottOra.osztaly_nevsor[j].osztalyzat, g) ? 'solid' : 'outline'"
                                (click)="jegyGombra(kivalasztottOra.osztaly_nevsor[j], g)">{{ g }}</ion-button>
                            </div>
                            <ion-input *ngIf="!jegyGombosMod(kivalasztottOra) && !nemIrtaJelE(kivalasztottOra.osztaly_nevsor[j].osztalyzat)"
                              type="number"
                              [placeholder]="kivalasztottOra?.osztalyozasimod === '2' ? '%' : '1-5'"
                              [min]="kivalasztottOra?.osztalyozasimod === '2' ? 0 : 1"
                              [max]="kivalasztottOra?.osztalyozasimod === '2' ? 100 : 5"
                              [(ngModel)]="kivalasztottOra.osztaly_nevsor[j].osztalyzat"></ion-input>
                            <span *ngIf="nemIrtaJelE(kivalasztottOra.osztaly_nevsor[j].osztalyzat)" class="nem-irta-cimke">nem írta meg</span>
                            <ion-button *ngIf="nemIrtaLehet" size="small" color="medium" class="nem-irta-gomb"
                              [fill]="nemIrtaJelE(kivalasztottOra.osztaly_nevsor[j].osztalyzat) ? 'solid' : 'outline'"
                              [title]="nemIrtaJelE(kivalasztottOra.osztaly_nevsor[j].osztalyzat) ? 'Kihúzás visszavonása' : 'Nem írta meg (–)'"
                              (click)="nemIrtaValt(kivalasztottOra.osztaly_nevsor[j])">–</ion-button>
                          </div>
                        </ng-template>
                      </td>
                    </tr>
                  </ng-container>
                </tbody>
              </table>
            </div>

        <!-- A MENTÉS a névsor alján tapadó sávban: görgetés közben is kéznél van. -->
        <div class="ertk-mentosav">
          <span class="ertk-lablec-sugo" *ngIf="!kivalasztottOra.szam_tipus || !kivalasztottOra.osztalyozasimod">
            <ion-icon name="information-circle-outline" aria-hidden="true"></ion-icon>
            A mentéshez válaszd ki a számonkérés típusát és az osztályozási módot.
          </span>
          <ion-button size="medium" color="primary" (click)="saveErtekeles()"
            [disabled]="jegyMentesFolyamatban || !kivalasztottOra.szam_tipus || !kivalasztottOra.osztalyozasimod"
            class="ertk-mentes">{{ jegyMentesFolyamatban ? 'Mentés…' : 'Mentés' }}</ion-button>
        </div>
      </ion-grid>


      <ion-grid *ngIf="kivalasztottOra && uzemmod == '5' && kivalasztottOra.osztaly_nevsor && kivalasztottOra.ertekelesek">
        <ion-row>
          <ion-col size="12">
            <ion-card class="zaro-card">
              <ion-card-header>
                <ion-card-title>Záróértékelések</ion-card-title>
                <ion-card-subtitle>
                  {{ kivalasztottOra?.tantargy || 'Tantárgy' }} | {{ kivalasztottOra.osztaly_nevsor.length }} fő
                </ion-card-subtitle>
              </ion-card-header>
              <ion-card-content>
                <!--  A II. és a IV. negyedév külön értékelés, nem a félévi / év végi (2026-11-02).
                      A negyedéves a hónapjában jelenik meg a jegyek között, N1–N4 jellel. -->
                <ion-segment [(ngModel)]="zaroTipus" (ionChange)="onZaroTipusValtozas()" [scrollable]="true">
                  <ion-segment-button value="4">
                    <ion-label>I. negyedév</ion-label>
                  </ion-segment-button>
                  <ion-segment-button value="6">
                    <ion-label>II. negyedév</ion-label>
                  </ion-segment-button>
                  <ion-segment-button value="2">
                    <ion-label>Félévi</ion-label>
                  </ion-segment-button>
                  <ion-segment-button value="5">
                    <ion-label>III. negyedév</ion-label>
                  </ion-segment-button>
                  <ion-segment-button value="7">
                    <ion-label>IV. negyedév</ion-label>
                  </ion-segment-button>
                  <ion-segment-button value="3">
                    <ion-label>Év végi</ion-label>
                  </ion-segment-button>
                </ion-segment>
                <p class="zaro-negyedev-megj" *ngIf="negyedevJel({ modja: zaroTipus }) as jel">
                  A negyedéves értékelés az Értékelések táblázatában a dátuma szerinti hónapban jelenik meg
                  ({{ jel }} jellel), és nem számít bele az átlagba. Nem azonos a félévi és az év végi értékeléssel.
                </p>

                <ion-row class="zaro-controls">
                  <ion-col size="12" sizeMd="4">
                    <ion-item class="ertekeles-form-item">
                      <ion-label position="stacked">Dátum</ion-label>
                      <ion-input type="date" [(ngModel)]="kivalasztottOra.datum"></ion-input>
                    </ion-item>
                  </ion-col>
                  <ion-col size="12" sizeMd="8">
                    <ion-item class="ertekeles-form-item">
                      <ion-label position="stacked">Megjegyzés / téma</ion-label>
                      <ion-input type="text" [placeholder]="getZaroCim()" [(ngModel)]="kivalasztottOra.szam_tema"></ion-input>
                    </ion-item>
                  </ion-col>
                </ion-row>

                <div class="zaro-list">
                  <div class="zaro-row zaro-row-header">
                    <div>Tanuló</div>
                    <div>Aktuális átlag</div>
                    <div>Műveletek</div>
                    <div>{{ getZaroCim() }}</div>
                  </div>
                  <div class="zaro-row" *ngFor="let n of kivalasztottOra.osztaly_nevsor">
                    <div class="zaro-nev">
                      <strong>{{ n.viselt_vez }} {{ n.viselt_ker }}</strong>
                      <small>{{ n.oktazon }}</small>
                    </div>
                    <div class="zaro-atlag">{{ getZaroAtlag(n) }}</div>
                    <div class="zaro-jegyek-action">
                      <ion-button size="small" fill="outline" color="primary" (click)="openZaroJegyek(n)">
                        Jegyek
                      </ion-button>
                      <ion-button size="small" fill="outline" color="tertiary" (click)="openZaroMondatbank(n)">
                        Mondatbank
                      </ion-button>
                      <ion-select
                        *ngIf="zaroFormak.length > 1"
                        interface="popover"
                        fill="outline"
                        label="Forma"
                        label-placement="stacked"
                        [(ngModel)]="n.ertekForma">
                        <ion-select-option *ngFor="let f of zaroFormak" [value]="f">{{ zaroFormaCimke[f] || f }}</ion-select-option>
                      </ion-select>
                      <ion-input
                        *ngIf="n.ertekForma === 'szazalek'"
                        type="number"
                        min="0"
                        max="100"
                        label="%"
                        label-placement="end"
                        fill="outline"
                        placeholder="0–100"
                        [(ngModel)]="n.ertek">
                      </ion-input>
                      <ion-select
                        *ngIf="n.ertekForma === 'jegy'"
                        interface="popover"
                        fill="outline"
                        label="Jegy"
                        label-placement="stacked"
                        placeholder="1–5"
                        [(ngModel)]="n.ertek">
                        <ion-select-option *ngFor="let j of zaroJegyOpciok" [value]="j">{{ j === '5D' ? '5D – dicséretes' : j }}</ion-select-option>
                      </ion-select>
                    </div>
                    <ion-textarea
                      #zaroTextarea
                      class="zaro-textarea"
                      autoGrow="true"
                      rows="3"
                      placeholder="Ide írható a szöveges értékelés..."
                      (ionFocus)="rememberZaroTextareaCursor(n, zaroTextarea)"
                      (click)="rememberZaroTextareaCursor(n, zaroTextarea)"
                      (keyup)="rememberZaroTextareaCursor(n, zaroTextarea)"
                      (ionInput)="rememberZaroTextareaCursor(n, zaroTextarea)"
                      [(ngModel)]="n.osztalyzat">
                    </ion-textarea>
                  </div>
                </div>

                <div class="zaro-actions">
                  <ion-button color="primary" (click)="saveZaroErtekeles()">Záróértékelések mentése</ion-button>
                </div>
              </ion-card-content>
            </ion-card>
          </ion-col>
        </ion-row>
      </ion-grid>

      <!-- ELŐZMÉNY (storno + napló, 2026-10-15): ki írta be, ki és mit módosított, ki stornózta és miért. -->
      <ion-modal class="elozmeny-modal" [isOpen]="!!elozmeny" (didDismiss)="elozmeny = null">
        <ng-template>
          <ion-header>
            <ion-toolbar color="primary">
              <ion-title>{{ elozmeny?.cim || 'Előzmény' }}</ion-title>
              <ion-buttons slot="end">
                <ion-button (click)="elozmeny = null">Bezár</ion-button>
              </ion-buttons>
            </ion-toolbar>
          </ion-header>
          <ion-content class="ion-padding">
            <p *ngIf="elozmeny?.betolt">Betöltés…</p>
            <p *ngIf="elozmeny?.hiba" class="storno-info">{{ elozmeny?.hiba }}</p>
            <p *ngIf="!elozmeny?.betolt && !elozmeny?.hiba && !elozmeny?.sorok?.length">
              Ehhez a tételhez még nincs naplóbejegyzés (a napló 2026. október 15-étől vezeti a változásokat).
            </p>
            <div class="elozmeny-sor" *ngFor="let e of elozmeny?.sorok || []" [class.elozmeny-storno]="e.muvelet === 'storno' || e.muvelet === 'torles'">
              <div class="elozmeny-fej">
                <b>{{ NAPLO_MUVELET[e.muvelet] || e.muvelet }}</b>
                <span>{{ e.ido }}</span>
                <span>{{ e.felhasznalo_nev || e.felhasznalo || 'ismeretlen' }}</span>
              </div>
              <div *ngIf="e.ok"><b>Oka:</b> {{ e.ok }}</div>
              <div *ngIf="e.muvelet === 'letrehozas' && e.utana">
                <span *ngIf="e.utana.ertekeles">Érték: {{ e.utana.ertekeles }}</span>
                <span *ngIf="e.utana.szoveg">{{ e.utana.szoveg }}</span>
                <span *ngIf="e.utana.cim"> {{ e.utana.cim }}</span>
                <span *ngIf="e.utana.targynap || e.utana.datum || e.utana.created_at"> · {{ e.utana.targynap || e.utana.datum || e.utana.created_at }}</span>
                <span *ngIf="e.utana.tema"> · {{ e.utana.tema }}</span>
              </div>
              <div *ngFor="let v of e.valtozasok" class="elozmeny-valtozas">
                {{ v.cimke }}: <s>{{ elozmenyErtek(v.elotte) }}</s> → <b>{{ elozmenyErtek(v.utana) }}</b>
              </div>
            </div>
          </ion-content>
        </ng-template>
      </ion-modal>

      <ion-modal
        class="zaro-jegyek-modal"
        [isOpen]="zaroJegyekModalOpen"
        (didDismiss)="closeZaroJegyek()">
        <ng-template>
          <ion-header>
            <ion-toolbar color="primary">
              <ion-title>
                {{ zaroJegyekTanulo?.viselt_vez }} {{ zaroJegyekTanulo?.viselt_ker }} jegyei
              </ion-title>
              <ion-buttons slot="end">
                <ion-button (click)="closeZaroJegyek()">Bezár</ion-button>
              </ion-buttons>
            </ion-toolbar>
          </ion-header>
          <ion-content class="ion-padding">
            <ion-card class="zaro-jegyek-card">
              <ion-card-header>
                <ion-card-title>{{ kivalasztottOra?.tantargy || kivtantargyNev || 'Tantárgy' }}</ion-card-title>
                <ion-card-subtitle>
                  Oktatási azonosító: {{ zaroJegyekTanulo?.oktazon }} | Aktuális átlag: {{ getZaroAtlag(zaroJegyekTanulo) }}
                </ion-card-subtitle>
              </ion-card-header>
              <ion-card-content>
                <div class="scrollable-table zaro-jegyek-table-wrap">
                  <table class="ertekeles zaro-jegyek-table">
                    <thead>
                      <tr>
                        <th *ngFor="let h of zaroElsoFelevHonapok">{{ h }}</th>
                        <th>I</th>
                        <th>Átlag</th>
                        <th *ngFor="let h of zaroMasodikFelevHonapok">{{ h }}</th>
                        <th>II</th>
                        <th>Átlag</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td *ngFor="let h of zaroElsoFelevHonapok">
                          <span *ngFor="let item of getZaroHonapJegyek(h); let k = index">
                            <ion-button [attr.data-negyedev]="negyedevJel(item) || null"
                              size="small"
                              fill="clear"
                              [id]="'zaro-jegy-elso-'+h+'-'+k" [class.storno-jegy]="stornoE(item)"
                              style="color:{{item.szin}};--padding-start:0;--padding-end:0;margin:0" [title]="jegyHover(item)">
                              <small *ngIf="negyedevesE(item)" class="negyedev-jel">{{negyedevJel(item)}}</small>{{jegyRovid(item)}}<ng-container *ngIf="!negyedevesE(item)">&nbsp;</ng-container>
                            </ion-button>
                            <ion-popover [trigger]="'zaro-jegy-elso-'+h+'-'+k" triggerAction="click" showBackdrop=false>
                              <ng-template>
                                <ion-content class="ion-padding">
                                  <b>Téma:</b> {{item.tema || '-'}}
                                  <span *ngIf="(item.ertekeles || '').length > 4"><br><b>Értékelés:</b> {{item.ertekeles}}</span>
                                  <span *ngIf="getSpecialErtekelesReszletek(item.ertekeles) as special"><br><b>Magatartás:</b> {{special.magatartas}}<br><b>Szorgalom:</b> {{special.szorgalom}}</span>
                                  <br><b>Dátum:</b> {{item.targynap || '-'}}
                                  <br><b>Súlyozás:</b> {{item.szorzo || '-'}}%
                                  <br><b>Típus:</b> {{item.emnev || '-'}}
                                  <br><b>Tanár:</b> {{formatErtekelesTanar(item)}}
                                  <span *ngIf="stornoE(item)" class="storno-info"><br><b>Stornózva:</b> {{item.storno_ido}}{{item.stornozta_nev ? ' – ' + item.stornozta_nev : ''}}<br><b>Oka:</b> {{item.storno_ok || '-'}}</span>
                                  <br><ion-button (click)="elozmenyMutat('tanulo_ertekeles', item, 'Jegy előzménye')" size="small" fill="clear">Előzmény</ion-button>
                                </ion-content>
                              </ng-template>
                            </ion-popover>
                          </span>
                        </td>
                        <td class="zaro-jegy-special-cell">
                          <span *ngFor="let fe of getZaroJegyekAdat()?.felevi || []; let u = index">
                            <ion-button
                              size="small"
                              fill="clear"
                              [id]="'zaro-jegy-felevi-'+u" [class.storno-jegy]="stornoE(fe)"
                              style="color:{{fe.szin}};--padding-start:0;--padding-end:0;margin:0" [title]="jegyHover(fe)">
                              {{jegyRovid(fe)}}&nbsp;
                            </ion-button>
                            <ion-popover [trigger]="'zaro-jegy-felevi-'+u" triggerAction="click" showBackdrop=false>
                              <ng-template>
                                <ion-content class="ion-padding">
                                  <b>Téma:</b> {{fe.tema || '-'}}
                                  <span *ngIf="(fe.ertekeles || '').length > 4"><br><b>Értékelés:</b> {{fe.ertekeles}}</span>
                                  <br><b>Dátum:</b> {{fe.targynap || '-'}}
                                  <br><b>Típus:</b> {{fe.emnev || '-'}}
                                  <br><b>Tanár:</b> {{formatErtekelesTanar(fe)}}
                                  <span *ngIf="stornoE(fe)" class="storno-info"><br><b>Stornózva:</b> {{fe.storno_ido}}{{fe.stornozta_nev ? ' – ' + fe.stornozta_nev : ''}}<br><b>Oka:</b> {{fe.storno_ok || '-'}}</span>
                                  <br><ion-button (click)="elozmenyMutat('tanulo_ertekeles', fe, 'Záróértékelés előzménye')" size="small" fill="clear">Előzmény</ion-button>
                                </ion-content>
                              </ng-template>
                            </ion-popover>
                          </span>
                        </td>
                        <td class="zaro-jegy-atlag-cell">{{formatAtlag(getZaroJegyekAdat()?.atlagErtekelesFelev, getZaroJegyekAdat()?.atlagErtekelesFelevSzazalek)}}</td>
                        <td *ngFor="let h of zaroMasodikFelevHonapok">
                          <span *ngFor="let item of getZaroHonapJegyek(h); let k = index">
                            <ion-button [attr.data-negyedev]="negyedevJel(item) || null"
                              size="small"
                              fill="clear"
                              [id]="'zaro-jegy-masodik-'+h+'-'+k" [class.storno-jegy]="stornoE(item)"
                              style="color:{{item.szin}};--padding-start:0;--padding-end:0;margin:0" [title]="jegyHover(item)">
                              <small *ngIf="negyedevesE(item)" class="negyedev-jel">{{negyedevJel(item)}}</small>{{jegyRovid(item)}}<ng-container *ngIf="!negyedevesE(item)">&nbsp;</ng-container>
                            </ion-button>
                            <ion-popover [trigger]="'zaro-jegy-masodik-'+h+'-'+k" triggerAction="click" showBackdrop=false>
                              <ng-template>
                                <ion-content class="ion-padding">
                                  <b>Téma:</b> {{item.tema || '-'}}
                                  <span *ngIf="(item.ertekeles || '').length > 4"><br><b>Értékelés:</b> {{item.ertekeles}}</span>
                                  <span *ngIf="getSpecialErtekelesReszletek(item.ertekeles) as special"><br><b>Magatartás:</b> {{special.magatartas}}<br><b>Szorgalom:</b> {{special.szorgalom}}</span>
                                  <br><b>Dátum:</b> {{item.targynap || '-'}}
                                  <br><b>Súlyozás:</b> {{item.szorzo || '-'}}%
                                  <br><b>Típus:</b> {{item.emnev || '-'}}
                                  <br><b>Tanár:</b> {{formatErtekelesTanar(item)}}
                                  <span *ngIf="stornoE(item)" class="storno-info"><br><b>Stornózva:</b> {{item.storno_ido}}{{item.stornozta_nev ? ' – ' + item.stornozta_nev : ''}}<br><b>Oka:</b> {{item.storno_ok || '-'}}</span>
                                  <br><ion-button (click)="elozmenyMutat('tanulo_ertekeles', item, 'Jegy előzménye')" size="small" fill="clear">Előzmény</ion-button>
                                </ion-content>
                              </ng-template>
                            </ion-popover>
                          </span>
                        </td>
                        <td class="zaro-jegy-special-cell">
                          <span *ngFor="let ev of getZaroJegyekAdat()?.evvegi || []; let u = index">
                            <ion-button
                              size="small"
                              fill="clear"
                              [id]="'zaro-jegy-evvegi-'+u" [class.storno-jegy]="stornoE(ev)"
                              style="color:{{ev.szin}};--padding-start:0;--padding-end:0;margin:0" [title]="jegyHover(ev)">
                              {{jegyRovid(ev)}}&nbsp;
                            </ion-button>
                            <ion-popover [trigger]="'zaro-jegy-evvegi-'+u" triggerAction="click" showBackdrop=false>
                              <ng-template>
                                <ion-content class="ion-padding">
                                  <b>Téma:</b> {{ev.tema || '-'}}
                                  <span *ngIf="(ev.ertekeles || '').length > 4"><br><b>Értékelés:</b> {{ev.ertekeles}}</span>
                                  <br><b>Dátum:</b> {{ev.targynap || '-'}}
                                  <br><b>Típus:</b> {{ev.emnev || '-'}}
                                  <br><b>Tanár:</b> {{formatErtekelesTanar(ev)}}
                                  <span *ngIf="stornoE(ev)" class="storno-info"><br><b>Stornózva:</b> {{ev.storno_ido}}{{ev.stornozta_nev ? ' – ' + ev.stornozta_nev : ''}}<br><b>Oka:</b> {{ev.storno_ok || '-'}}</span>
                                  <br><ion-button (click)="elozmenyMutat('tanulo_ertekeles', ev, 'Záróértékelés előzménye')" size="small" fill="clear">Előzmény</ion-button>
                                </ion-content>
                              </ng-template>
                            </ion-popover>
                          </span>
                        </td>
                        <td class="zaro-jegy-atlag-cell">{{formatAtlag(getZaroJegyekAdat()?.atlagErtekeles, getZaroJegyekAdat()?.atlagErtekelesSzazalek)}}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </ion-card-content>
            </ion-card>
          </ion-content>
        </ng-template>
      </ion-modal>

      <ion-modal
        class="zaro-mondatbank-modal"
        [isOpen]="zaroMondatbankModalOpen"
        (didDismiss)="closeZaroMondatbank()">
        <ng-template>
          <ion-header>
            <ion-toolbar color="primary">
              <ion-title>
                Mondatbank - {{ zaroMondatbankTanulo?.viselt_vez }} {{ zaroMondatbankTanulo?.viselt_ker }}
              </ion-title>
              <ion-buttons slot="end">
                <ion-button (click)="closeZaroMondatbank()">Bezár</ion-button>
              </ion-buttons>
            </ion-toolbar>
          </ion-header>
          <ion-content class="ion-padding">
            <ion-card class="zaro-mondatbank-card">
              <ion-card-header>
                <ion-card-title>{{ getZaroTantargyNev() || 'Tantárgy' }}</ion-card-title>
                <ion-card-subtitle>
                  {{ getZaroCim() }} | {{ getZaroEvfolyam() || '-' }}. évfolyam
                </ion-card-subtitle>
              </ion-card-header>
              <ion-card-content>
                <ion-searchbar
                  class="zaro-mondatbank-search"
                  placeholder="Keresés a mondatok között..."
                  [(ngModel)]="zaroMondatbankKereses">
                </ion-searchbar>

                <div *ngIf="zaroMondatbankLoading" class="zaro-mondatbank-state">
                  Mondatok betöltése...
                </div>

                <div *ngIf="!zaroMondatbankLoading && !getFilteredZaroMondatbank().length" class="zaro-mondatbank-state">
                  Nincs találat ehhez az évfolyamhoz és tantárgyhoz.
                </div>

                <div class="zaro-mondatbank-list" *ngIf="!zaroMondatbankLoading && getFilteredZaroMondatbank().length">
                  <div
                    class="zaro-mondatbank-item"
                    [class.zaro-mondatbank-heading]="isZaroMondatbankCimke(item)"
                    *ngFor="let item of getFilteredZaroMondatbank()">
                    <div class="zaro-mondatbank-meta">
                      <ion-badge color="light">{{ item.tantargy }}</ion-badge>
                      <ion-badge color="medium">{{ item.ertekeles_tipus }}</ion-badge>
                      <ion-badge color="tertiary">{{ item.evfolyam }}. évfolyam</ion-badge>
                    </div>
                    <p>{{ item.szoveg }}</p>
                    <ion-button *ngIf="!isZaroMondatbankCimke(item)" size="small" color="primary" (click)="insertZaroMondat(item)">
                      Beszúrás
                    </ion-button>
                  </div>
                </div>
              </ion-card-content>
            </ion-card>
          </ion-content>
        </ng-template>
      </ion-modal>


      <ion-grid *ngIf="uzemmod == '6'">
        <ion-row *ngIf="!egysegKulcs || !kivtantargy">
          <ion-col>
            <ion-card class="szamonkeres-card">
              <ion-card-header>
                <ion-card-title>Számonkérések előrejelzése</ion-card-title>
                <ion-card-subtitle>Válassz osztályt vagy csoportot és tantárgyat a tervezett dolgozatok, témazárók rögzítéséhez.</ion-card-subtitle>
              </ion-card-header>
            </ion-card>
          </ion-col>
        </ion-row>

        <ion-row *ngIf="egysegKulcs && kivtantargy">
          <ion-col size="12" sizeLg="4">
            <ion-card class="szamonkeres-card">
              <ion-card-header>
                <ion-card-title>{{ szamonkeresForm.id ? 'Számonkérés szerkesztése' : 'Új számonkérés' }}</ion-card-title>
                <ion-card-subtitle>{{ kivtantargyNev || 'Tantárgy' }}</ion-card-subtitle>
              </ion-card-header>
              <ion-card-content>
                <ion-item class="szamonkeres-form-item">
                  <ion-label position="stacked">Dátum*</ion-label>
                  <ion-input type="date" [(ngModel)]="szamonkeresForm.datum"></ion-input>
                </ion-item>

                <ion-item class="szamonkeres-form-item">
                  <label class="ertekeles-form-label" for="szamonkeres-tipus">Számonkérés típusa</label>
                  <select id="szamonkeres-tipus" class="ertekeles-select" [(ngModel)]="szamonkeresForm.tipus">
                    <option [ngValue]="null">Nincs megadva</option>
                    <option
                      [ngValue]="it.id"
                      [disabled]="isTechnikaiErtekelesTipus(it)"
                      *ngFor="let it of valaszthatoTipusok(szamonkeresForm.tipus)">
                      {{it.nev}}
                    </option>
                  </select>
                </ion-item>

                <ion-item class="szamonkeres-form-item">
                  <ion-label position="stacked">Cím*</ion-label>
                  <ion-input type="text" placeholder="Pl. témazáró dolgozat" [(ngModel)]="szamonkeresForm.cim"></ion-input>
                </ion-item>

                <ion-item class="szamonkeres-form-item">
                  <ion-label position="stacked">Leírás</ion-label>
                  <ion-textarea rows="5" placeholder="Tananyag, felkészülési információk..." [(ngModel)]="szamonkeresForm.leiras"></ion-textarea>
                </ion-item>

                <div class="szamonkeres-actions">
                  <ion-button color="primary" (click)="saveSzamonkeres()" [disabled]="szamonkeresMentFolyamatban">
                    {{ szamonkeresForm.id ? 'Módosítás mentése' : 'Számonkérés mentése' }}
                  </ion-button>
                  <ion-button fill="clear" color="medium" (click)="resetSzamonkeresForm()" *ngIf="szamonkeresForm.id">
                    Mégse
                  </ion-button>
                </div>
              </ion-card-content>
            </ion-card>
          </ion-col>

          <ion-col size="12" sizeLg="8">
            <ion-card class="szamonkeres-card">
              <ion-card-header>
                <ion-card-title>Tervezett számonkérések</ion-card-title>
                <ion-card-subtitle>{{ eloSzamonkeresDb }} rögzített elem<span *ngIf="szamonkeresek.length > eloSzamonkeresDb"> · {{ szamonkeresek.length - eloSzamonkeresDb }} stornózva (áthúzva)</span></ion-card-subtitle>
              </ion-card-header>
              <ion-card-content>
                <div class="szamonkeres-empty" *ngIf="!szamonkeresek.length">
                  {{ kivcsoport ? 'Ehhez a csoporthoz' : 'Ehhez az osztályhoz' }} és tantárgyhoz még nincs bejelentett számonkérés.
                </div>

                <div class="szamonkeres-list" *ngIf="szamonkeresek.length">
                  <div class="szamonkeres-item" *ngFor="let item of szamonkeresek" [class.storno-tetel]="stornoE(item)">
                    <div class="szamonkeres-date">
                      <strong>{{ item.datum }}</strong>
                      <span>{{ item.tipus_nev || 'Típus nélkül' }}</span>
                    </div>
                    <div class="szamonkeres-main">
                      <h3>{{ item.cim }}</h3>
                      <p *ngIf="item.leiras">{{ item.leiras }}</p>
                      <!-- Osztályt választva a lista a csoportok dolgozatait is mutatja (ugyanazokat
                           a tanulókat terhelik) – ezeknél kiírjuk, melyik csoporté. -->
                      <small *ngIf="item.csoport_nev && !kivcsoport">Csoport: {{ item.csoport_nev }} · </small>
                      <small>Rögzítette: {{ item.tanar_nev || item.tanar || '-' }}</small>
                      <small *ngIf="stornoE(item)" class="storno-info"><br>Stornózva{{ item.torles_ido ? ': ' + item.torles_ido : '' }}{{ item.torolte_nev ? ' – ' + item.torolte_nev : '' }}{{ item.torles_ok ? ' · Oka: ' + item.torles_ok : '' }}</small>
                    </div>
                    <div class="szamonkeres-row-actions">
                      <ion-button *ngIf="!stornoE(item)" size="small" fill="clear" (click)="editSzamonkeres(item)">Szerkesztés</ion-button>
                      <ion-button *ngIf="!stornoE(item)" size="small" fill="clear" color="danger" (click)="deleteSzamonkeres(item)">Stornó</ion-button>
                      <ion-button size="small" fill="clear" color="medium" (click)="elozmenyMutat('szamonkeres_terv', item, 'Számonkérés előzménye')">Előzmény</ion-button>
                    </div>
                  </div>
                </div>
              </ion-card-content>
            </ion-card>
          </ion-col>
        </ion-row>
      </ion-grid>



      <ion-grid *ngIf="kivalasztottOra && kivalasztottOra.osztalyok && uzemmod == '2'">
        
        <!--h2>{{kivosztaly}}
            </h2-->
        <h2>Névsor - {{kivalasztottOra.osztalyok[0].tanulok.length}} fő</h2>
        <div style="text-align: center" id="magyarazat">
          <ion-chip>
            <ion-icon name="browsers" color="light"></ion-icon>
            <ion-label>Nincs adat</ion-label>
          </ion-chip>
          <ion-chip>
            <ion-icon name="browsers" color="dark"></ion-icon>
            <ion-label>Nincs tanóra</ion-label>
          </ion-chip>
          <ion-chip>
            <ion-icon name="browsers" color="tertiary"></ion-icon>
            <ion-label>Igazolandó</ion-label>
          </ion-chip>
          <ion-chip>
            <ion-icon name="browsers" color="success"></ion-icon>
            <ion-label>Igazolt</ion-label>
          </ion-chip>
          <ion-chip>
            <ion-icon name="browsers" color="danger"></ion-icon>
            <ion-label>Igazolatlan</ion-label>
          </ion-chip>
          <ion-chip>
            <ion-icon name="browsers" color="secondary"></ion-icon>
            <ion-label>Orvosi igazolás</ion-label>
          </ion-chip>
        </div>
        <ion-button size="medium" color="primary" (click)="saveMulasztas()" *ngIf="mulasztasIgazolhat">Mentés</ion-button>
        <ion-item lines="none" *ngIf="mulasztasIgazolhat" class="egesz-nap-kapcsolo">
          <ion-toggle [(ngModel)]="egeszNap" labelPlacement="end">
            Egész napos jelölés – egy kattintás a diák aznapi összes órájára hat (pl. CSEHÓ-nap, kirándulás)
          </ion-toggle>
        </ion-item>
        <ion-note color="medium" *ngIf="mulasztasIgazolhat" class="tkt-bk-megjegyzes">
          Kattintásonként: <b>igazolt</b> (a sor végén választott típussal) → <b>igazolatlan</b> →
          <b>igazolandó</b> (lila: hiányzott, a döntés később) → nincs hiányzás. Végül <b>Mentés</b>.
        </ion-note>
        <p class="tkt-bk-megjegyzes" *ngIf="!mulasztasIgazolhat">
          A hiányzások igazolását az osztályfőnök, a helyettese (vagy adminisztrátor) végzi – itt csak megnézni lehet.
        </p>

        <ion-row>
          <ion-col>
            <div class="scrollable-table mulasztas-gorgeto">
              <table class="ertekeles mulasztas-tabla">
                <thead>
                  <tr>
                    <th rowspan="2">#</th>
                    <th rowspan="2" class="nev-oszlop" style="border-right:2px solid black">Név</th>

                    <ng-container *ngFor="let nap of mulasztasNapok">
                      <th [style]="(index+1) % 9 == 0 ? 'border-right:2px solid black' : ''"
                        *ngFor="let j of [].constructor(9); let index=index">{{index+1}}</th>
                    </ng-container>
                    <th rowspan="2" class="tipus-oszlop">Igazolás módja</th>
                  </tr>
                  <tr>
                    <th style="border-right:2px solid black" colspan="9"
                      *ngFor="let nap of mulasztasNapok">{{mulasztasNapNevek[nap]}}<br><small class="nap-datum">{{ (kivalasztottOra.datumok && kivalasztottOra.datumok[nap] || '').slice(5).replace('-', '.') }}</small></th>
                  </tr>
                </thead>
                <tbody>
                  <ng-container *ngFor="let n of kivalasztottOra.osztalyok[0].tanulok; let j = index">
                    <tr>
                      <td>{{j+1}}.</td>
                      <td class="nev-oszlop" style="border-right:2px solid black"><app-profilkep class="nevsor-kep" tipus="tanulo" [azon]="n.oktazon" [nev]="n.tanulo_nev"></app-profilkep>{{n.tanulo_nev}}</td>
                      <ng-container *ngFor="let h of mulasztasNapok">
                        <td class="ora-cella" (click)="changeOra(j,h,k)" [style]="n.orarend_igazolasok[h] ? igHatter(n.orarend_igazolasok[h]?.orak[k]) : 'background-color:grey;cursor: not-allowed;'"
                          *ngFor="let orak of [].constructor(9); let k = index"
                          [title]="n.orarend_igazolasok[h] ? mulasztasCim(n.orarend_igazolasok[h]?.orak[k]) : 'Nincs adat'">
                          <ion-icon *ngIf="n.orarend_igazolasok[h] && mulasztasZarolt(n.orarend_igazolasok[h]?.orak[k])" name="lock-closed" style="font-size:11px;color:white;vertical-align:middle"></ion-icon>
                        </td>
                      </ng-container>
                      <td class="tipus-oszlop"><ng-select [readonly]="!mulasztasIgazolhat"
                          appendTo="body" [notFoundText]="'Nincs találat'" [items]="mulasztas_tipus"
                          placeholder="Igazolás típusa*" bindValue="id" [multiple]="false" [closeOnSelect]="true"
                          label-placement="stacked" bindLabel="nev" [(ngModel)]="n.globaltipus">
                        </ng-select></td>


                    </tr>
                  </ng-container>
                </tbody>
              </table>
            </div>
          </ion-col>
        </ion-row>
      </ion-grid>



      <ion-grid *ngIf="kivalasztottOra && uzemmod == '3'">
        <!--h2>{{kivosztaly}}
            </h2-->
        <ion-modal [class]="'nagy1'" #feljegyzesModal>
          <ng-template>
            <ion-header>
              <ion-toolbar color="primary">
                <ion-title>{{ feljegyzesForm?.id ? 'Feljegyzés módosítása' : 'Új feljegyzés' }}</ion-title>
                <ion-buttons slot="end">
                  <ion-button style="background: white;border-radius: 5px;" (click)="feljegyzesModal.dismiss()" [strong]="true" shape="round" color="primary">Bezár</ion-button>
                  <ion-button style="background: white;border-radius: 5px;" (click)="mentFeljegyzes()" [strong]="true" shape="round" color="secondary" [disabled]="!feljegyzesMentheto()">Mentés</ion-button>
                </ion-buttons>
              </ion-toolbar>
            </ion-header>
            <ion-content class="ion-padding feljegyzes-modal-content">
              <ion-item class="feljegyzes-form-item">
                <ion-label position="stacked">Tanuló</ion-label>
                <ion-input [value]="(aktivFeljegyzesTanulo?.viselt_vez || '') + ' ' + (aktivFeljegyzesTanulo?.viselt_ker || '')" readonly></ion-input>
              </ion-item>
              <ion-item class="feljegyzes-form-item">
                <ion-label position="stacked">Dátum</ion-label>
                <ion-input type="date" [(ngModel)]="feljegyzesForm.datum"></ion-input>
              </ion-item>
              <ion-item class="feljegyzes-form-item feljegyzes-select-item">
                <ion-label position="stacked">Típus</ion-label>
                <ng-select class="feljegyzes-tipus-select" appendTo="body" [notFoundText]="'Nincs találat'" [items]="feljegyzesTipusok || []" bindLabel="nev" bindValue="nev" [multiple]="false" [closeOnSelect]="true" [(ngModel)]="feljegyzesForm.tipus" (ngModelChange)="feljegyzesTipusValtozott()" placeholder="Típus kiválasztása"></ng-select>
              </ion-item>
              <!-- A TÍPUS SAJÁT MEZŐI (pl. korlátozott tárgy – mobil – használatának engedélye, 245/2024.
                   Korm. r. 5. §: cél, időtartam, tárgy; Nkt. 24. § (4) b): engedélyező). A séma a kiszolgálóé;
                   a feljegyzés szövegét a kiszolgáló írja a mezőkből, a szöveg mező itt megjegyzés. -->
              <ng-container *ngIf="feljegyzesMezok() as mezok">
                <ng-container *ngFor="let m of mezok">
                  <ion-item class="feljegyzes-form-item feljegyzes-select-item" *ngIf="feljegyzesMezoLatszik(m)">
                    <ion-label position="stacked">{{ m.cimke }}{{ m.kotelezo ? ' *' : '' }}</ion-label>
                    <ion-input *ngIf="m.tipus === 'szoveg'" [(ngModel)]="feljegyzesForm.adatok[m.kulcs]" [placeholder]="m.pl || ''"></ion-input>
                    <ion-input *ngIf="m.tipus === 'datum'" type="date" [(ngModel)]="feljegyzesForm.adatok[m.kulcs]"></ion-input>
                    <ng-select *ngIf="m.tipus === 'valaszto'" class="feljegyzes-tipus-select" appendTo="body" [notFoundText]="'Nincs találat'"
                               [items]="m.opciok || []" [addTag]="!!m.egyeb" addTagText="Más:" [multiple]="false" [closeOnSelect]="true"
                               [(ngModel)]="feljegyzesForm.adatok[m.kulcs]" [placeholder]="m.egyeb ? 'Válassz, vagy írd be' : 'Válassz'"></ng-select>
                    <ng-select *ngIf="m.tipus === 'dolgozo'" class="feljegyzes-tipus-select" appendTo="body" [notFoundText]="'Nincs találat'"
                               [items]="feljegyzesDolgozok" [addTag]="true" addTagText="Más név:" [multiple]="false" [closeOnSelect]="true"
                               [(ngModel)]="feljegyzesForm.adatok[m.kulcs]" placeholder="Engedélyező"></ng-select>
                    <ion-note *ngIf="m.sugo" color="medium" class="feljegyzes-mezo-sugo">{{ m.sugo }}</ion-note>
                  </ion-item>
                </ng-container>
              </ng-container>
              <ion-item class="feljegyzes-form-item">
                <ion-label position="stacked">{{ feljegyzesMezok() ? 'Megjegyzés (nem kötelező)' : 'Szöveg' }}</ion-label>
                <ion-textarea autoGrow="true" [rows]="feljegyzesMezok() ? 2 : 5" [(ngModel)]="feljegyzesForm.szoveg"></ion-textarea>
              </ion-item>
              <ion-note *ngIf="feljegyzesMezok()" color="medium" class="feljegyzes-mezo-sugo ion-padding-start">
                A feljegyzés szövegét a rendszer a fenti mezőkből állítja össze; a szülő és a tanuló ezt látja.
              </ion-note>
            </ion-content>
          </ng-template>
        </ion-modal>
<!--ion-card color="danger">
          <ion-card-header color="danger">
            <ion-card-title><ion-icon name="alert-circle-outline"></ion-icon> Fejlesztés alatt!</ion-card-title>
            <ion-card-subtitle>A menü jelenleg csak lekérésre alkalmas. Jegy beírásához használja a Napló
              funkciót!</ion-card-subtitle>
          </ion-card-header>
        </ion-card-->
        <h2>Névsor - {{kivalasztottOra[egysegKulcs].tanulok.length}} fő</h2>
        <ion-row>
          <ion-col>
            <div class="scrollable-table">
              <table class="ertekeles">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Név</th>
                    <th>09</th>
                    <th>10</th>
                    <th>11</th>
                    <th>12</th>
                    <th>01</th>
                    <th>02</th>
                    <th>03</th>
                    <th>04</th>
                    <th>05</th>
                    <th>06</th>
                  </tr>
                </thead>
                <tbody>
                  <ng-container *ngFor="let n of kivalasztottOra[egysegKulcs].feljegyzesek.tanulok; let j = index">
                    <tr>
                      <td>{{j+1}}.</td>
                          <td><app-profilkep class="nevsor-kep" tipus="tanulo" [azon]="n.oktazon" [nev]="n.viselt_vez + ' ' + n.viselt_ker"></app-profilkep>{{n.viselt_vez}} {{n.viselt_ker}} <ion-button size="small" fill="clear" (click)="ujFeljegyzes(n)"><ion-icon
                            slot="icon-only" name="add"></ion-icon></ion-button></td>
                      <td *ngFor="let h of ['09','10','11','12','01','02','03','04','05','06']"><span
                          *ngFor="let item of n?.months[h]; let k = index">
                          <ion-button size="medium" fill="clear" [id]="'hover-trigger'+h+j+k" [class.storno-jegy]="stornoE(item)"
                            style="color:{{item.tipus.includes('hiány') || item.tipus.includes('figyelmeztetés') || item.tipus.includes('Na') ? 'red':'green'}};--padding-start:0;--padding-end:0;margin:0" [title]="jegyHover(item)">{{item.created_at.slice(8,10)}}&nbsp;</ion-button>
                          <ion-popover [trigger]="'hover-trigger'+h+j+k" triggerAction="click" showBackdrop=false>
                            <ng-template>
                              <ion-content class="ion-padding"><b>Értékelés:</b>
                                <span style="white-space:pre-line">{{item.szoveg}}</span><br><b>Dátum:</b>
                                {{item.created_at.slice(0,10)}}<br><b>Típus:</b>
                                {{item.tipus}}<br>
                                <span *ngIf="item.cim"><b>Cím:</b> {{item.cim}}<br></span>
                                <span *ngIf="item.forras === 'kreta'" class="feljegyzes-jel">a KRÉTÁ-ból</span>
                                <span *ngIf="item.kreta_allapot === 'visszairasra_var'" class="feljegyzes-jel var">KRÉTÁ-ba visszaírandó</span>
                                <span *ngIf="item.kreta_allapot === 'helyi'" class="feljegyzes-jel" title="Ennek a típusnak nincs KRÉTA-megfelelője">csak a SULINFORM-ban</span>
                                <br *ngIf="item.forras === 'kreta' || item.kreta_allapot === 'visszairasra_var' || item.kreta_allapot === 'helyi'">
                                <span *ngIf="stornoE(item)" class="storno-info"><b>Stornózva</b><span *ngIf="item.torles_ido">: {{item.torles_ido | date:'yyyy.MM.dd. HH:mm'}}</span><span *ngIf="item.torles_ok"><br><b>Oka:</b> {{item.torles_ok}}</span><span *ngIf="!item.torolte && item.forras === 'kreta'"> (a KRÉTÁ-ban törölték)</span><br></span>
                                <ng-container *ngIf="feljegyzesSzerkesztheto(item) && !stornoE(item)">
                                  <ion-button (click)="szerkesztFeljegyzes(item, n)" size="small" fill="outline">Módosítás</ion-button>
                                  <ion-button (click)="torolFeljegyzes(item)" size="small" color="danger">Stornó</ion-button>
                                </ng-container>
                                <small *ngIf="!feljegyzesSzerkesztheto(item) && !stornoE(item)" class="feljegyzes-jel">Ezt a típust csak adminisztrátor módosíthatja.</small>
                                <ion-button (click)="elozmenyMutat('feljegyzesek', item, 'Feljegyzés előzménye')" size="small" fill="clear">Előzmény</ion-button>
                              </ion-content>
                            </ng-template>
                          </ion-popover></span></td>
                    </tr>
                  </ng-container>
                </tbody>
              </table>
            </div>
          </ion-col>
        </ion-row>
      </ion-grid>





      <!-- ═══════ Szülői hiányzás-igazolás (uzemmod 4) ═══════ -->
      <ion-grid *ngIf="uzemmod == '4'">
        <div class="hi-ures" *ngIf="!kivtanulo">
          Válaszd ki fent a gyermeket a hiányzások megtekintéséhez.
        </div>

        <ng-container *ngIf="kivtanulo && hi">
          <!-- Keret -->
          <ion-card class="hi-keret">
            <ion-card-content>
              <div class="hi-keret-sor">
                <div>
                  <b>Igazolható napok kerete ebben a tanévben:</b>
                  <span class="hi-szam">{{ hi.felhasznalt }} / {{ hi.keret_nap }}</span>
                  felhasználva
                </div>
                <ion-badge [color]="hi.maradek > 0 ? 'success' : 'warning'">
                  {{ hi.maradek > 0 ? hi.maradek + ' nap maradt' : 'A keret elfogyott' }}
                </ion-badge>
              </div>
              <ion-note color="medium">
                A keretbe csak a <b>szülői igazolással</b> igazolt napok számítanak. Ha elfogyott, a szülői
                igazolás <b>igazgatói engedélyre vár</b> – a kérést itt tudod beadni, és itt látod az eredményét is.
                Az <b>orvosi</b> vagy <b>hivatalos</b> igazolás (pl. nyelvvizsga) nem a keretből megy: a
                dokumentumot feltöltve az osztályfőnök bírálja el. Amit az iskola orvosi igazolásként
                rögzít, azt a szülői igazolás nem írja felül, és az a nap sem terheli a keretet.
              </ion-note>
            </ion-card-content>
          </ion-card>

          <!-- Igazolásra váró napok -->
          <ion-card>
            <ion-card-header>
              <ion-card-title>Igazolásra váró napok</ion-card-title>
            </ion-card-header>
            <ion-card-content>
              <div class="hi-ures" *ngIf="!hiVanBeadhato">
                Nincs igazolásra váró hiányzás. 🎉
              </div>

              <ion-note color="medium" *ngIf="tanuloNezet && hiVanBeadhato" style="display:block;margin-bottom:8px">
                Ezeket a napokat a <b>szülőd</b> tudja igazolni a saját belépésével, vagy az osztályfőnököd
                rögzíti az igazolást.
              </ion-note>

              <div class="hi-nap" *ngFor="let nap of hiIgazolando">
                <ion-checkbox *ngIf="!tanuloNezet" [checked]="hiKijelolt[nap.datum]"
                              (ionChange)="hiKijelolt[nap.datum] = $event.detail.checked"></ion-checkbox>
                <div class="hi-nap-adat">
                  <b>{{ nap.datum }}</b>
                  <span class="hi-orak">
                    {{ nap.igazolando_db }} igazolandó óra
                    <span class="hi-tantargyak">({{ hiTantargyak(nap) }})</span>
                  </span>
                </div>
              </div>

              <!--  Kézzel felvett napok: a hiányzást még nem rögzítették a naplóban. -->
              <div class="hi-nap" *ngFor="let d of hiKeziNapok">
                <ion-checkbox [checked]="hiKijelolt[d]"
                              (ionChange)="hiKijelolt[d] = $event.detail.checked"></ion-checkbox>
                <div class="hi-nap-adat">
                  <b>{{ d }}</b>
                  <span class="hi-orak">a hiányzás még nincs rögzítve a naplóban</span>
                </div>
                <ion-button size="small" fill="clear" color="medium" (click)="hiKeziTorol(d)">
                  <ion-icon slot="icon-only" name="close-outline"></ion-icon>
                </ion-button>
              </div>

              <!--  NEM LÁTOD A NAPOT? A naplót gyakran később töltik ki; a szülő addig se
                    maradjon beadási lehetőség nélkül. -->
              <div class="hi-kezi" *ngIf="!hi.tanev_lezart && !tanuloNezet">
                <span class="hi-orak">Nem látod a napot a listában? Ha a hiányzást még nem rögzítették, add hozzá:</span>
                <input type="date" class="hi-datum" [(ngModel)]="hiKeziDatum"
                       [min]="hi.tanev_kezd" [max]="hiMa">
                <ion-button size="small" fill="outline" (click)="hiKeziHozzaad()" [disabled]="!hiKeziDatum">
                  <ion-icon slot="start" name="add-outline"></ion-icon>
                  Nap hozzáadása
                </ion-button>
              </div>

              <div class="hi-beadas" *ngIf="hiVanBeadhato && !tanuloNezet">
                <ion-select label="Az igazolás fajtája" label-placement="stacked" fill="outline"
                            interface="popover" [(ngModel)]="hiTipus">
                  <ion-select-option *ngFor="let t of hiTipusok" [value]="t.id">{{ t.nev }}</ion-select-option>
                </ion-select>
                <ion-textarea label="Indoklás" label-placement="stacked" fill="outline" [autoGrow]="true"
                              rows="2" [(ngModel)]="hiIndoklas"
                              [placeholder]="hiDokumentumos ? 'pl. nyelvvizsga, orvosi vizsgálat' : 'pl. betegség, családi ok'"></ion-textarea>
                <ion-note color="medium" *ngIf="hiDokumentumos && !hiPalyavalasztas">
                  Az orvosi és a hivatalos igazolást az osztályfőnök bírálja el a feltöltött dokumentum
                  alapján, ezért ehhez a <b>melléklet kötelező</b>. A szülői keretet nem terheli.
                </ion-note>
                <!--  PÁLYAVÁLASZTÁSI CÉLÚ TÁVOLLÉT (20/2012. EMMI r. 51. § (2) e)): 7–8. és 10–12. évfolyam,
                      tanévente legfeljebb 2 alkalom, a szervező intézmény igazolásával. -->
                <ion-note color="medium" *ngIf="hiPalyavalasztas && hi.palyavalasztas">
                  Pályaválasztási célú rendezvény (pl. nyílt nap) miatti távollét: tanévente legfeljebb
                  <b>{{ hi.palyavalasztas.keret }} alkalom</b> (napon) igazolható, a <b>szervező intézmény igazolásával</b>
                  (melléklet kötelező), az osztályfőnök bírálja el. A szülői keretet nem terheli.
                  Ebben a tanévben eddig: <b>{{ hi.palyavalasztas.felhasznalt }} / {{ hi.palyavalasztas.keret }}</b>
                  <span *ngIf="hi.palyavalasztas.napok?.length">({{ hi.palyavalasztas.napok.join(', ') }})</span>.
                </ion-note>
                <ion-note color="danger" *ngIf="hiPalyaTullepes > 0">
                  A kijelölt napokból {{ hiPalyaTullepes }} már a pályaválasztási kereten felül van – így nem adható be.
                  Kevesebb napot jelölj ki, vagy válassz más fajtát.
                </ion-note>
                <!--  MELLÉKLET. Szülői igazolásnál opcionális; orvosi/hivatalos igazolásnál
                      kötelező, mert annak a papír az alapja. -->
                <div class="hi-melleklet">
                  <input type="file" id="hi-fajl" (change)="hiFajlValaszt($event)"
                         accept="image/*,application/pdf" hidden>
                  <ion-button size="small" fill="outline" [color]="hiDokumentumos && !hiFajl ? 'warning' : 'medium'"
                              onclick="document.getElementById('hi-fajl').click()">
                    <ion-icon slot="start" name="document-attach-outline"></ion-icon>
                    Melléklet csatolása {{ hiDokumentumos ? '(kötelező)' : '(nem kötelező)' }}
                  </ion-button>
                  <ion-note color="medium" *ngIf="hiFajl">{{ hiFajl.name }}</ion-note>
                  <!--  PÓTLÁS. Ha a melléklet elsőre nem ment fel, az igazolás akkor is
                        beadva van és a nap levonódott – zsákutca helyett újrapróbálható. -->
                  <ion-button size="small" color="warning" *ngIf="hiUtolsoIdk.length && hiFajl"
                              (click)="hiMellekletPotlas()" [disabled]="hiFolyamatban">
                    <ion-icon slot="start" name="refresh-outline"></ion-icon>
                    Melléklet pótlása
                  </ion-button>
                </div>
                <ion-button (click)="hiIgazol()"
                            [disabled]="hiFolyamatban || !hiKijeloltDb || (hiDokumentumos && !hiFajl) || hiPalyaTullepes > 0">
                  <ion-icon slot="start" name="checkmark-circle-outline"></ion-icon>
                  {{ hiDokumentumos ? 'Beküldöm elbírálásra' : (hi.maradek > 0 ? 'Igazolom' : 'Igazgatói engedély kérése') }}
                  ({{ hiKijeloltDb }} nap)
                </ion-button>
                <ion-note color="warning" *ngIf="!hiDokumentumos && hiKijeloltDb > hi.maradek">
                  A kijelölt napokból {{ hiKijeloltDb - hi.maradek }} már a kereten felül van –
                  azok igazgatói engedélyre várnak majd.
                </ion-note>
              </div>
            </ion-card-content>
          </ion-card>

          <!-- Késések. A törvény szerint a késések ideje összeadódik, és amikor eléri egy
               tanóra hosszát, igazolt vagy igazolatlan órának minősül – ezért itt, a
               hiányzások mellett a helye, nem külön menüben. -->
          <ion-card *ngIf="keses">
            <ion-card-header>
              <ion-card-title>Késések</ion-card-title>
              <ion-card-subtitle>
                A késések ideje összeadódik. Ha eléri a {{ keses.perc_egy_ora }} percet, egy órának
                minősül – attól függően igazoltnak vagy igazolatlannak, hogy a pedagógus igazolta-e.
              </ion-card-subtitle>
            </ion-card-header>
            <ion-card-content>
              <div class="ke-osszegzes">
                <div class="ke-kartya baj">
                  <b>{{ keses.ora_igazolatlan }}</b><span>igazolatlan óra késésből</span>
                  <small>{{ keses.perc_igazolatlan }} perc, ebből {{ keses.maradek_igazolatlan }} még nem teljes óra</small>
                </div>
                <div class="ke-kartya ok">
                  <b>{{ keses.ora_igazolt }}</b><span>igazolt óra késésből</span>
                  <small>{{ keses.perc_igazolt }} perc</small>
                </div>
                <div class="ke-kartya">
                  <b>{{ keses.kovetkezo_orahoz }}</b><span>perc a következő igazolatlan óráig</span>
                </div>
              </div>

              <div class="hi-ures" *ngIf="!keses.tetelek?.length">
                Ebben a tanévben nincs rögzített késés. 🎉
              </div>

              <div class="ke-tabla-burok" *ngIf="keses.tetelek?.length">
                <table class="ke-tabla">
                  <thead>
                    <tr><th>Dátum</th><th>Óra</th><th>Tantárgy</th><th class="szam">Késés</th><th>Állapot</th><th>Indok</th></tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let t of keses.tetelek">
                      <td>{{ t.datum | date: 'yyyy. MM. dd.' }}</td>
                      <td class="szam">{{ t.oraszam ?? '—' }}</td>
                      <td>{{ t.tantargy_nev || '—' }}</td>
                      <td class="szam">{{ t.perc }} perc</td>
                      <td>
                        <ion-badge [color]="t.igazolt ? 'success' : 'danger'">
                          {{ t.igazolt ? 'igazolt' : 'igazolatlan' }}
                        </ion-badge>
                      </td>
                      <td>{{ t.indok || '—' }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </ion-card-content>
          </ion-card>

          <!-- Korábbi igazolások -->
          <ion-card>
            <ion-card-header>
              <ion-card-title>Beadott igazolások</ion-card-title>
            </ion-card-header>
            <ion-card-content>
              <div class="hi-ures" *ngIf="!hi.igazolasok?.length">Még nincs beadott igazolás.</div>
              <input type="file" id="hi-potlo-fajl" (change)="hiPotloFajl($event)"
                     accept="image/*,application/pdf" hidden>
              <div class="hi-igazolas" *ngFor="let i of hi.igazolasok">
                <b>{{ i.datum }}</b>
                <ion-badge [color]="i.statusz === 'igazolt' ? 'success'
                                   : i.statusz === 'elutasitva' ? 'danger'
                                   : i.statusz === 'visszavonva' ? 'medium' : 'warning'">
                  {{ hiAllapot(i) }}
                </ion-badge>
                <ion-badge color="tertiary" *ngIf="i.tipus && i.tipus !== 2">{{ i.tipus_nev }}</ion-badge>
                <!--  A számláló és a lista ne mondjon ellent egymásnak: ha egy szülői igazolással
                      beadott napot az iskola orvosiként rögzített, az nem fogy a keretből. -->
                <ion-note color="success" *ngIf="i.statusz === 'igazolt' && i.tipus === 2 && !i.keretet_terheli">
                  nem terheli a keretet
                </ion-note>
                <span class="hi-indok" *ngIf="i.indoklas">{{ i.indoklas }}</span>
                <span class="hi-indok hi-elbiralas" *ngIf="i.elbiralas_indok">
                  Igazgatói döntés: {{ i.elbiralas_indok }}
                </span>
                <!--  LÁTSZIK, VAN-E PAPÍR – ÉS MEG IS NÉZHETŐ. A feltöltés eddig némán
                      bukott el, ezért kell a visszajelzés; a megnyitás pedig azért, mert a
                      gondviselő maga akarja ellenőrizni, olvasható-e, amit beküldött.
                      A fájl a belépési jeggyel töltődik le (nem sima link), különben a
                      kiszolgáló – helyesen – nem adná ki. -->
                <a class="hi-csatolmany" *ngFor="let c of i.csatolmanyok"
                   (click)="hiCsatolmanyNyit(c)" [title]="c.nev">
                  <ion-icon name="document-attach-outline"></ion-icon> {{ c.nev }}
                </a>
                <ion-badge color="medium" *ngIf="i.csatolmany_db && !i.csatolmanyok?.length">
                  {{ i.csatolmany_db }} melléklet
                </ion-badge>
                <ion-button size="small" fill="clear" *ngIf="!tanuloNezet" (click)="hiPotloValaszt(i)" [disabled]="hiFolyamatban">
                  <ion-icon slot="start" name="document-attach-outline"></ion-icon>
                  {{ i.csatolmany_db ? 'Még egy melléklet' : 'Melléklet csatolása' }}
                </ion-button>
              </div>
            </ion-card-content>
          </ion-card>

          <!-- Teljes hiányzás-lista -->
          <ion-card>
            <ion-card-header>
              <ion-card-title>Összes hiányzás ({{ hi.napok?.length || 0 }} nap)</ion-card-title>
            </ion-card-header>
            <ion-card-content>
              <!--  TÍPUSONKÉNTI ÖSSZESÍTŐ: a tanuló és a gondviselő lássa, mivel igazolták a
                    hiányzásait (orvosi, szülői, iskolaérdekű…), és mennyi az igazolatlan. -->
              <div class="hi-tipus-osszesito" *ngIf="hi.tipus_osszesites?.length">
                <span class="hi-tipus-db" *ngFor="let t of hi.tipus_osszesites">
                  <ion-badge [color]="hiOraSzin(t.igazolas_tipus)">{{ t.tipus_nev }}</ion-badge>
                  <b>{{ t.ora_db }} óra</b>
                </span>
              </div>
              <div class="hi-ures" *ngIf="!hi.napok?.length">Ebben a tanévben nincs rögzített hiányzás.</div>
              <div class="hi-nap hi-osszes hi-osszes-nap" *ngFor="let nap of hi.napok">
                <div class="hi-osszes-fej">
                  <div class="hi-nap-adat">
                    <b>{{ nap.datum }}</b>
                    <span class="hi-orak">{{ nap.ora_db }} óra</span>
                  </div>
                  <ion-badge [color]="nap.rendezett ? 'success' : 'warning'">
                    {{ nap.rendezett ? 'Rendezett' : nap.igazolando_db + ' igazolandó' }}
                  </ion-badge>
                </div>
                <!--  Óránként: sorszám, tantárgy és az óra állapota (az igazolás típusa,
                      igazolandó vagy igazolatlan). -->
                <div class="hi-ora-sor" *ngFor="let o of nap.orak">
                  <span class="hi-ora-szam">{{ o.ora }}. óra</span>
                  <span class="hi-ora-tantargy">{{ o.tantargy || '—' }}</span>
                  <ion-badge [color]="hiOraSzin(o.igazolas_tipus)">{{ o.tipus_nev }}</ion-badge>
                </div>
              </div>
            </ion-card-content>
          </ion-card>
        </ng-container>
      </ion-grid>








    </div>


  </div>
  <ion-modal class="nagy" style="z-index: 1000" #orarendmodal id="orarendmodal">
    <ng-template>
      <ion-header [translucent]="true">
        <ion-toolbar color="primary">
          <ion-buttons slot="end">
            <ion-button [disabled]="!formo.valid" (click)="orarendmodal.dismiss(1)" role="saved"
              style="background: white; border-radius: 5px" [strong]="true" shape="round"
              color="secondary">Mentés</ion-button>
          </ion-buttons>
          <ion-buttons slot="start">
            <ion-button (click)="orarendmodal.dismiss()" [strong]="true" shape="round" color="dark"
              style="background: white; border-radius: 5px">Bezár</ion-button>
          </ion-buttons>
          <ion-title>Órarend</ion-title>
        </ion-toolbar>
      </ion-header>
      <ion-content>
        <form [formGroup]="formo">
          <ion-col>
            <ion-card>
              <ion-card-header>
                <ion-card-title>Alapadatok</ion-card-title>
              </ion-card-header>
              <ion-card-content style="margin:5px">

                <ion-row>
                  <ion-col>
                    <div class="input-button-container">
                      <div style="color:black"
                        class="sc-ion-input-md-h sc-ion-input-md-s md label-floating input-fill-outline input-label-placement-stacked hydrated">
                        <label class="input-wrapper sc-ion-input-md" for="ion-input-szi">
                          <div class="input-outline-container sc-ion-input-md">
                            <div class="input-outline-start sc-ion-input-md"></div>
                            <div class="input-outline-notch sc-ion-input-md">
                              <div class="notch-spacer sc-ion-input-md" aria-hidden="true">Állomány</div>
                            </div>
                            <div class="input-outline-end sc-ion-input-md"></div>
                          </div>
                          <div class="label-text-wrapper sc-ion-input-md">
                            <div class="label-text sc-ion-input-md">Állomány</div>
                          </div>
                          <div class="native-wrapper sc-ion-input-md sc-ion-input-md-s">
                            <ion-icon name="globe" aria-hidden="true"></ion-icon>
                            <ng-select appendTo="body" [notFoundText]="'Nincs találat'" [items]="allomanyKi"
                              bindValue="adid" [multiple]="true" [closeOnSelect]="true" formControlName="selectedUser"
                              bindLabel="full_name">

                            </ng-select>
                          </div>
                        </label>
                      </div>
                    </div>
                  </ion-col>
                </ion-row><ion-row>
                  <ion-col>
                    <ion-select interface="popover" placeholder="" label="Osztály / Csoport" formControlName="osztaly"
                      label-placement="stacked" fill="outline">
                      <ion-icon slot="start" name="cash" aria-hidden="true"></ion-icon>
                      <ion-select-option *ngFor="let o of osztaly" [value]="o.id">{{o.osztaly}}</ion-select-option>
                    </ion-select>
                  </ion-col>
                  <ion-col>
                    <ion-select interface="popover" placeholder="" label="Hetirend" formControlName="hetirend"
                      label-placement="stacked" fill="outline">
                      <ion-icon slot="start" name="cash" aria-hidden="true"></ion-icon>
                      <ion-select-option value="O">Minden héten</ion-select-option>
                      <ion-select-option value="A">A héten</ion-select-option>
                      <ion-select-option value="B">B héten</ion-select-option>
                    </ion-select>
                  </ion-col>
                  <ion-col>
                    <ion-select interface="popover" placeholder="" label="Időtartam" formControlName="ido"
                      label-placement="stacked" fill="outline">
                      <ion-icon slot="start" name="cash" aria-hidden="true"></ion-icon>
                      <ion-select-option value="O">Teljes tanév</ion-select-option>
                      <ion-select-option value="I">I. Félév</ion-select-option>
                      <ion-select-option value="II">II. Félév</ion-select-option>
                      <ion-select-option value="A">Ettől a héttől</ion-select-option>
                      <ion-select-option value="B">Eddig a hétig</ion-select-option>
                      <ion-select-option value="C">Csak ez az óra</ion-select-option>
                    </ion-select>
                  </ion-col>
                  <!--ion-col>
                    <ion-input label="Árfolyam" label-placement="stacked" fill="outline" placeholder=""
                      formControlName="arfolyam"><ion-icon slot="start" name="time"
                        aria-hidden="true"></ion-icon></ion-input>
                  </ion-col-->
                </ion-row><ion-row>
                  <ion-col>
                    <ion-select interface="popover" placeholder="" label="Tantárgy" formControlName="tantargy"
                      label-placement="stacked" fill="outline">
                      <ion-icon slot="start" name="cash" aria-hidden="true"></ion-icon>
                      <ion-select-option *ngFor="let t of tantargyEgysegbenLista" [value]="t.id">{{t.name}}</ion-select-option>
                    </ion-select>
                  </ion-col>
                  <ion-col>
                    <ion-select interface="popover" placeholder="" label="Tanterem" formControlName="tanterem"
                      label-placement="stacked" fill="outline">
                      <ion-icon slot="start" name="cash" aria-hidden="true"></ion-icon>
                      <ion-select-option *ngFor="let t of terem" [value]="t.id">{{t.name}}</ion-select-option>
                    </ion-select>
                  </ion-col>
                  <ion-col>
                    <ion-input label="Hossz" label-placement="stacked" fill="outline" placeholder="" type="number"
                      formControlName="hossz"><ion-icon slot="start" name="time"
                        aria-hidden="true"></ion-icon></ion-input>
                  </ion-col>
                </ion-row>

              </ion-card-content>
            </ion-card>
          </ion-col>


          <ion-col>
            <ion-card>
              <ion-card-header>
                <ion-card-title>Tanóra órarendi adatai</ion-card-title>
              </ion-card-header>
              <ion-card-content style="margin:5px">
                <ion-row>
                  <ion-col>
                    <ion-input label="Tanóra kezdődátuma" label-placement="stacked" fill="outline" placeholder=""
                      [readonly]="true" type="date" max="3000-12-31" formControlName="erv_kezd"><ion-icon slot="start"
                        name="time" aria-hidden="true"></ion-icon></ion-input><br>

                    <ion-modal [keepContentsMounted]="true">
                      <ng-template>
                        <ion-datetime style="border: 1px solid;" id="datetime" [firstDayOfWeek]="1" presentation="date"
                          [formatOptions]="{
                  date: {
                    year: 'numeric',
                    month: 'long',
                    day: '2-digit',
                  },
                }"></ion-datetime>
                      </ng-template>
                    </ion-modal>
                  </ion-col>
                  <ion-col>
                    <ion-input [readonly]="true" label="Órarendi nap" label-placement="stacked" fill="outline"
                      placeholder="" formControlName="nap"><ion-icon slot="start" name="time"
                        aria-hidden="true"></ion-icon></ion-input>
                  </ion-col>
                  <ion-col>
                    <ion-input [readonly]="true" label="Órarendi nap" label-placement="stacked" fill="outline"
                      placeholder="" formControlName="napszam"><ion-icon slot="start" name="time"
                        aria-hidden="true"></ion-icon></ion-input>
                  </ion-col>
                  <ion-col>
                    <ion-input [readonly]="true" label="Hányadik óra?" label-placement="stacked" fill="outline"
                      placeholder="" formControlName="ora"><ion-icon slot="start" name="time"
                        aria-hidden="true"></ion-icon></ion-input>
                  </ion-col>
                </ion-row>
                <ion-row>

                </ion-row>
              </ion-card-content>
            </ion-card>
          </ion-col>


          <!--ion-col>
            <ion-card>
              <ion-card-header>
                <ion-card-title>Órarendi napra vonatkozó adatok</ion-card-title>
              </ion-card-header>
              <ion-card-content style="margin:5px">
                <ion-col>
                  <ion-select interface="popover" placeholder="" label="Csengetési rend" formControlName="csengetes"
                    label-placement="stacked" fill="outline">
                    <ion-icon slot="start" name="cash" aria-hidden="true"></ion-icon>
                    <ion-select-option *ngFor="let t of terem" [value]="t.id">{{t.name}}</ion-select-option>
                  </ion-select>
                </ion-col>
              </ion-card-content>
            </ion-card>
          </ion-col-->


        </form>
      </ion-content>
    </ng-template>
  </ion-modal>

  <ion-modal class="nagy1" style="z-index: 1000" #helyettesitesmodal id="helyettesitesmodal">
    <ng-template>
      <ion-header [translucent]="true">
        <ion-toolbar color="primary">
          <ion-buttons slot="end">
            <ion-button [disabled]="!formh.valid" (click)="helyettesitesmodal.dismiss(2)" role="saved"
              style="background: white;border-radius: 5px" [strong]="true" shape="round"
              color="danger">Törlés</ion-button>
            <ion-button [disabled]="!formh.valid" (click)="helyettesitesmodal.dismiss(1)" role="saved"
              style="background: white; border-radius: 5px" [strong]="true" shape="round"
              color="secondary">Mentés</ion-button>
          </ion-buttons>
          <ion-buttons slot="start">
            <ion-button (click)="helyettesitesmodal.dismiss()" [strong]="true" shape="round" color="dark"
              style="background: white; border-radius: 5px">Bezár</ion-button>
          </ion-buttons>
          <ion-title>Helyettesítés</ion-title>
        </ion-toolbar>
      </ion-header>
      <ion-content>
        <form [formGroup]="formh">
          <ion-col>
            <ion-card>
              <ion-card-header>
                <ion-card-title>Alapadatok</ion-card-title>
              </ion-card-header>
              <ion-card-content style="margin:5px">

                <ion-row>
                  <ion-col>
                    <ion-input [readonly]="true" label="Hányadik óra?" label-placement="stacked" fill="outline"
                      placeholder="" style="display:none"></ion-input>
                    <div class="input-button-container">
                      <div style="color:black"
                        class="sc-ion-input-md-h sc-ion-input-md-s md label-floating input-fill-outline input-label-placement-stacked hydrated">
                        <label class="input-wrapper sc-ion-input-md" for="ion-input-szi">
                          <div class="input-outline-container sc-ion-input-md">
                            <div class="input-outline-start sc-ion-input-md"></div>
                            <div class="input-outline-notch sc-ion-input-md">
                              <div class="notch-spacer sc-ion-input-md" aria-hidden="true">Helyettesítő</div>
                            </div>
                            <div class="input-outline-end sc-ion-input-md"></div>
                          </div>
                          <div class="label-text-wrapper sc-ion-input-md">
                            <div class="label-text sc-ion-input-md">Helyettesítő</div>
                          </div>
                          <div class="native-wrapper sc-ion-input-md sc-ion-input-md-s" *ngIf="formh.value.mod !='O'">
                            <ion-icon name="globe" aria-hidden="true"></ion-icon>
                            <ng-select appendTo="body" [notFoundText]="'Nincs találat'" [items]="allomanyKi"
                              bindValue="adid" [multiple]="false" [closeOnSelect]="true" formControlName="selectedUser"
                              bindLabel="full_name">

                            </ng-select>
                          </div>
                          <div class="native-wrapper sc-ion-input-md sc-ion-input-md-s" *ngIf="formh.value.mod =='O'">
                            <ion-icon name="globe" aria-hidden="true"></ion-icon>
                            <ng-select appendTo="body" [notFoundText]="'Nincs találat'" [items]="allomanyBe"
                              bindValue="adid" [multiple]="false" [closeOnSelect]="true" formControlName="selectedUser"
                              bindLabel="full_name">

                            </ng-select>
                          </div>
                        </label>
                      </div>
                    </div>
                  </ion-col>
                </ion-row><ion-row>
                  <!--ion-col>
                    <ion-select interface="popover" placeholder="" label="Időtartam" formControlName="ido"
                      label-placement="stacked" fill="outline">
                      <ion-icon slot="start" name="cash" aria-hidden="true"></ion-icon>
                      <ion-select-option value="O">Teljes tanév</ion-select-option>
                      <ion-select-option value="I">I. Félév</ion-select-option>
                      <ion-select-option value="II">II. Félév</ion-select-option>
                      <ion-select-option value="A">Ettől a héttől</ion-select-option>
                      <ion-select-option value="B">Eddig a hétig</ion-select-option>
                      <ion-select-option value="C">Csak ez az óra</ion-select-option>
                    </ion-select>
                  </ion-col-->
                  <ion-col>
                    <ion-select interface="popover" placeholder="" label="Módja" formControlName="mod"
                      label-placement="stacked" fill="outline">
                      <ion-icon slot="start" name="cash" aria-hidden="true"></ion-icon>
                      <ion-select-option value="H">Helyettesítés</ion-select-option>
                      <ion-select-option value="O">Összevonás</ion-select-option>
                      <ion-select-option value="E">Elmaradt</ion-select-option>
                    </ion-select>
                  </ion-col>
                  <ion-col>
                    <ion-select interface="popover" placeholder="" label="Típus" formControlName="tipus"
                      label-placement="stacked" fill="outline">
                      <ion-icon slot="start" name="cash" aria-hidden="true"></ion-icon>
                      <ion-select-option value="E">Eseti</ion-select-option>
                      <ion-select-option value="T">Tartós</ion-select-option>
                      <ion-select-option value="S">Szívességi</ion-select-option>
                    </ion-select>
                  </ion-col>
                  <!--ion-col>
                    <ion-input label="Árfolyam" label-placement="stacked" fill="outline" placeholder=""
                      formControlName="arfolyam"><ion-icon slot="start" name="time"
                        aria-hidden="true"></ion-icon></ion-input>
                  </ion-col-->
                </ion-row>

              </ion-card-content>
            </ion-card>
          </ion-col>


        </form>
      </ion-content>
    </ng-template>
  </ion-modal>

  <ion-modal (willDismiss)="onWillDismiss($event)" [style.--height]="'250px'">
    <ng-template>
      <ion-header>
        <ion-toolbar [style.--background]="kivalasztottora.szin" [style.color]="'white'">
          <!--ion-buttons slot="start">
          <ion-button (click)="cancel()">Bezár</ion-button>
        </ion-buttons-->
          <ion-title>Tanóra: {{kivalasztottora.evfolyam.osztaly}} {{kivalasztottora.rovid ?? kivalasztottora.nev}} -
            {{allomany[kivalasztottora.ttfel.munkatars].intezmenyadatok.kod ??
            allomany[kivalasztottora.ttfel.munkatars].oktazon}} ({{kivalasztottora.orarend.hossz}}db)</ion-title>
          <ion-buttons slot="end">
            <ion-button style="background: white;border-radius: 5px;" (click)="cancel()" [strong]="true"
              [disabled]="validateForm()" shape="round" [style.color]="kivalasztottora.szin">Bezár</ion-button>
          </ion-buttons>
        </ion-toolbar>
      </ion-header>
      <ion-content class="ion-padding" style="margin:auto;text-align: center;">
        <ion-button size="large" [style.--background]="kivalasztottora.szin">
          Óra módosítása
          <ion-icon slot="start" name="create"></ion-icon>
        </ion-button>
        <ion-button size="large" color="warning" *ngIf="kivalasztottora.orarend?.locked != 1">
          Lezárás
          <ion-icon slot="start" name="lock-closed"></ion-icon>
        </ion-button>
        <ion-button size="large" color="dark" *ngIf="kivalasztottora.orarend?.locked == 1">
          Feloldás
          <ion-icon slot="start" name="lock-open"></ion-icon>
        </ion-button>
        <ion-button size="large" color="danger" (click)="delOrarend()"
          [disabled]="kivalasztottora.orarend?.locked == 1">
          Törlés
          <ion-icon slot="start" name="trash"></ion-icon>
        </ion-button>
      </ion-content>
    </ng-template>
  </ion-modal>
</ion-content>
